// import { useState, useEffect, useRef, useContext, useCallback } from "react";
// import { Client } from "@stomp/stompjs";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck, faCheckDouble } from "@fortawesome/free-solid-svg-icons";
// import { motion, AnimatePresence } from "framer-motion";
// import { useLocation, useNavigate } from "react-router-dom";
// import EmojiPicker from "emoji-picker-react";
// import Image1 from "../../assets/logoo.png"

// const WS_URL = "wss://waws.deetyasoft.com/sendMessage";

// const Chat = () => {
//   const [config, setConfig] = useState({ apiKey: "", baseUrl: "", domain: "" });
//   const [isConfigLoaded, setIsConfigLoaded] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [contacts, setContacts] = useState([]);
//   const [selectedContact, setSelectedContact] = useState(null);
//   const [messages, setMessages] = useState({});
//   const [newMessage, setNewMessage] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [chatLoading, setChatLoading] = useState(false);
//   const [sending, setSending] = useState(false);
//   const [error, setError] = useState(null);
//   const [isMobileView, setIsMobileView] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [fileType, setFileType] = useState("text");
//   const [replyingTo, setReplyingTo] = useState(null);
//   const [wsConnected, setWsConnected] = useState(false);
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false);

//   const [currentPage, setCurrentPage] = useState(0);
//   const [pageSize, setPageSize] = useState(20);
//   const [totalMessages, setTotalMessages] = useState(0);
//   const [hasMoreMessages, setHasMoreMessages] = useState(true);
//   const [loadingMore, setLoadingMore] = useState(false);

//   const [activeMenu, setActiveMenu] = useState(null);

//   const fileInputRef = useRef(null);
//   const messagesEndRef = useRef(null);
//   const handledNotifRef = useRef(null);
//   const inputRef = useRef(null);
//   const chatContainerRef = useRef(null);
  
//   const previousScrollHeightRef = useRef(0);
//   const shouldMaintainScrollRef = useRef(false);
  
//   const pendingMessagesRef = useRef(new Map());
  
//   const stompClientRef = useRef(null);
//   const subscriptionsRef = useRef({});
//   const contactsRef = useRef([]);
//   const selectedContactRef = useRef(null);

//   const { user } = useContext(AuthContext);
//   const token = user?.token || localStorage.getItem("token");
//   const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//   // Local Storage functions for syncing Unread Messages globally
//   const getStoredUnreadCounts = useCallback(() => {
//     try {
//       return JSON.parse(localStorage.getItem(`wa_unread_${companyId}`) || "{}");
//     } catch {
//       return {};
//     }
//   }, [companyId]);

//   const updateStoredUnreadCount = useCallback((number, count) => {
//     const stored = getStoredUnreadCounts();
//     if (count <= 0) {
//       delete stored[number];
//     } else {
//       stored[number] = count;
//     }
//     localStorage.setItem(`wa_unread_${companyId}`, JSON.stringify(stored));
//     window.dispatchEvent(new Event("wa_unread_changed"));
//   }, [companyId, getStoredUnreadCounts]);

//   const getAvatarInitials = (name) => {
//     if (!name) return "U";
//     return String(name).charAt(0).toUpperCase();
//   };

//   const getAvatarColor = (name) => {
//     const colors = [
//       "bg-red-500", "bg-blue-500", "bg-green-500", "bg-yellow-500",
//       "bg-purple-500", "bg-pink-500", "bg-indigo-500", "bg-teal-500", "bg-orange-500"
//     ];
//     if (!name) return colors[0];
//     let hash = 0;
//     for (let i = 0; i < name.length; i++) {
//       hash = name.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     return colors[Math.abs(hash) % colors.length];
//   };

//   const buildApiUrl = (endpoint) => {
//     const d = (config.domain || "").replace(/\/+$/, "");
//     const b = (config.baseUrl || "").replace(/^\/+|\/+$/g, "");
//     const e = (endpoint || "").replace(/^\/+/, "");

//     let finalUrl = d;
//     if (b) finalUrl += `/${b}`;
//     if (e) finalUrl += `/${e}`;

//     return finalUrl;
//   };

//   const getMediaSrc = (message) => {
//     if (message.mediaUrl) return message.mediaUrl;
//     if (message.mediaId) {
//       return `https://waapi.deetyasoft.com/api/lms/whatsapp-config/media?apiKey=${config.apiKey}&mediaId=${message.mediaId}`;
//     }
//     return null;
//   };

//   useEffect(() => {
//     const fetchConfig = async () => {
//       try {
//         const response = await fetch(`${API_URL}/api/whatsappConfig/${companyId}`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });
//         const result = await response.json();

//         if (response.ok && result.status === "success" && result.data) {
//           setConfig({
//             apiKey: result.data.apiKey || "",
//             baseUrl: result.data.baseUrl || "",
//             domain: result.data.domain || "",
//           });
//           setIsConfigLoaded(true);
//         } else {
//           setError("WhatsApp configuration not found. Please set it up in settings.");
//           setLoading(false);
//         }
//       } catch (err) {
//         console.error("Failed to load WhatsApp configuration:", err);
//         setError("Failed to load WhatsApp API configuration.");
//         setLoading(false);
//       }
//     };

//     if (companyId) {
//       fetchConfig();
//     }
//   }, [companyId, token]);

//   useEffect(() => {
//     const checkScreenSize = () => setIsMobileView(window.innerWidth <= 768);
//     checkScreenSize();
//     window.addEventListener("resize", checkScreenSize);
//     return () => window.removeEventListener("resize", checkScreenSize);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (!e.target.closest('.message-menu-container') && !e.target.closest('.menu-trigger-btn')) {
//         setActiveMenu(null);
//       }
//     };
//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, []);

//   const scrollToBottom = () => {
//     if (!shouldMaintainScrollRef.current) {
//       setTimeout(() => {
//         messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//       }, 100);
//     }
//   };

//   useEffect(() => {
//     if (!loadingMore && !chatLoading) {
//       scrollToBottom();
//     }
//   }, [messages, selectedContact, loadingMore, chatLoading]);

//   useEffect(() => {
//     selectedContactRef.current = selectedContact;
//   }, [selectedContact]);

//   const extractOriginalMessageId = (frontendId) => {
//     if (!frontendId || typeof frontendId !== "string") return null;
//     const parts = frontendId.split("-");
//     if (parts[0].startsWith("wamid.")) return parts[0];
//     return frontendId;
//   };

//   const formatMessageDate = (timestamp) => {
//     const date = new Date(timestamp);
//     const now = new Date();
//     const yesterday = new Date(now);
//     yesterday.setDate(yesterday.getDate() - 1);

//     if (date.toDateString() === now.toDateString()) return "Today";
//     if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
//     return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
//   };

//   const formatSidebarTime = (timestamp) => {
//     if (!timestamp) return "";
//     const date = new Date(timestamp);
//     const now = new Date();
//     const yesterday = new Date(now);
//     yesterday.setDate(yesterday.getDate() - 1);

//     if (date.toDateString() === now.toDateString()) {
//       return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     }
//     if (date.toDateString() === yesterday.toDateString()) {
//       return "Yesterday";
//     }
//     return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
//   };

//   const shouldShowDateSeparator = (currentMessage, previousMessage) => {
//     if (!previousMessage) return true;
//     const currentDate = new Date(currentMessage.timestamp).toDateString();
//     const previousDate = new Date(previousMessage.timestamp).toDateString();
//     return currentDate !== previousDate;
//   };

//   const DateSeparator = ({ date }) => (
//     <div className="flex justify-center my-4">
//       <div className="bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded-md shadow-sm">
//         <span className="text-xs text-gray-600 dark:text-gray-300 font-medium tracking-wide">
//           {date}
//         </span>
//       </div>
//     </div>
//   );

//   const fetchUniqueSenders = async () => {
//     if (!isConfigLoaded || !config.domain || !config.apiKey) return;

//     try {
//       setLoading(true);
//       setError(null);

//       const senderItems = [];
//       let senderPage = 0;
//       let hasMoreSenders = true;
//       let senderFetchOk = true;

//       while (hasMoreSenders && senderPage < 50) {
//         const url = new URL(`${API_URL}/api/whatsapp-chat/unique-senders`);
//         url.searchParams.append("page", senderPage);
//         url.searchParams.append("size", 100);

//         const pageResponse = await fetch(url.toString(), {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         if (!pageResponse.ok) {
//           senderFetchOk = false;
//           break;
//         }

//         const pageData = await pageResponse.json();
//         senderItems.push(...(pageData.data || []));
//         hasMoreSenders = !!pageData.hasMore;
//         senderPage = pageData.nextPage;
//       }

//       if (senderFetchOk) {
//         const storedUnread = getStoredUnreadCounts();
        
//         const formattedContacts = senderItems
//           .filter((item) => item && item.number)
//           .map((item, index) => {
//             const backendUnread = item.unreadCount || 0;
//             const localUnread = storedUnread[item.number] || 0;
//             const finalUnread = Math.max(backendUnread, localUnread);

//             // Sync with local storage if backend sent higher value
//             if (finalUnread > localUnread) {
//               updateStoredUnreadCount(item.number, finalUnread);
//             }

//             return {
//               id: index + 1,
//               name: String(item.contactName || item.number),
//               number: String(item.number),
//               contactName: String(item.contactName || item.number),
//               time: item.time,
//               lastMessage: item.time ? `Active: ${new Date(item.time).toLocaleDateString()}` : "",
//               unreadCount: finalUnread,
//             };
//           });

//         setContacts(formattedContacts);
//         const initialMessages = {};
//         formattedContacts.forEach((contact) => (initialMessages[contact.id] = []));
//         setMessages((prev) => ({ ...initialMessages, ...prev }));
//       } else {
//         throw new Error("Failed to fetch contacts");
//       }
//     } catch (error) {
//       console.error("Error fetching contacts:", error);
//       setError(error.message || "Failed to load contacts");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (isConfigLoaded) {
//       fetchUniqueSenders();
//     }
//   }, [isConfigLoaded]);

//   useEffect(() => {
//     const targetNumber = location.state?.openContactNumber;
//     if (!targetNumber) return;
//     if (handledNotifRef.current === targetNumber) return;
//     if (contacts.length === 0) return;

//     const match = contacts.find((c) => c.number === targetNumber);
//     if (match) {
//       handledNotifRef.current = targetNumber;
//       handleContactSelect(match);
//       navigate(location.pathname, { replace: true, state: {} });
//     }
//   }, [contacts, location.state, navigate, location.pathname]);

//   const fetchChatMessages = async (contact, page = 0, append = false) => {
//     if (!isConfigLoaded || !contact || !contact.number) return;

//     try {
//       if (append) {
//         setLoadingMore(true);
//         if (chatContainerRef.current) {
//           previousScrollHeightRef.current = chatContainerRef.current.scrollHeight;
//         }
//         shouldMaintainScrollRef.current = true;
//       } else {
//         setChatLoading(true);
//         shouldMaintainScrollRef.current = false;
//         pendingMessagesRef.current.clear();
//         setCurrentPage(0);
//       }

//       const url = new URL(`${API_URL}/api/whatsapp-chat/chat`);
//       url.searchParams.append("sender", contact.number);
//       url.searchParams.append("page", page);
//       url.searchParams.append("size", pageSize);

//       const response = await fetch(url.toString(), {
//         method: "GET",
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (response.ok) {
//         const data = await response.json();
        
//         if (data.total !== undefined) {
//           setTotalMessages(data.total);
//           const totalPages = Math.ceil(data.total / pageSize);
//           const nextPage = page + 1;
//           setHasMoreMessages(nextPage < totalPages);
//         }

//         const messagesData = data.data || [];
//         const sortedMessages = [...messagesData].sort((a, b) => {
//           const timeA = new Date(a.timestamp || a.time || 0);
//           const timeB = new Date(b.timestamp || b.time || 0);
//           return timeA - timeB;
//         });

//         const formattedMessages = sortedMessages.map((msg, index) => {
//           const messageId = msg.wamid || msg.messageId || `local-${Date.now()}-${index}`;
//           const isPending = pendingMessagesRef.current.has(messageId);
          
//           let messageText = msg.message || msg.text || "";
//           const messageType = msg.type || "text";
          
//           if (messageType === "image" && !messageText) {
//             messageText = "📷 Photo";
//           } else if (messageType === "video" && !messageText) {
//             messageText = "🎥 Video";
//           } else if (messageType === "audio" && !messageText) {
//             messageText = "🎵 Audio";
//           } else if (messageType === "document" && !messageText) {
//             messageText = "📄 Document";
//           }
          
//           return {
//             id: messageId,
//             text: messageText,
//             sender: msg.direction === "INCOMING" ? "them" : "me",
//             time: msg.timestamp
//               ? new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
//               : new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//             timestamp: msg.timestamp || new Date().toISOString(),
//             type: messageType,
//             mediaId: msg.mediaId,
//             mediaUrl: msg.mediaUrl,
//             status: isPending ? "sent" : (msg.status || "read"),
//             replyTo: msg.replyTo || null,
//             reaction: msg.reaction || null,
//           };
//         });

//         setMessages((prev) => {
//           const contactId = contact.id;
          
//           if (append) {
//             const existingMessages = prev[contactId] || [];
//             const existingIds = new Set(existingMessages.map(m => m.id));
//             const newMessages = formattedMessages.filter(m => !existingIds.has(m.id));
            
//             return {
//               ...prev,
//               [contactId]: [...newMessages, ...existingMessages],
//             };
//           } else {
//             const pendingMsgs = Array.from(pendingMessagesRef.current.values())
//               .filter(p => p.contactId === contactId);
            
//             const pendingIds = new Set(pendingMsgs.map(p => p.id));
//             const filteredMessages = formattedMessages.filter(m => !pendingIds.has(m.id));
            
//             return {
//               ...prev,
//               [contactId]: [...filteredMessages, ...pendingMsgs],
//             };
//           }
//         });
//       } else {
//         throw new Error("Failed to fetch chat messages");
//       }
//     } catch (error) {
//       console.error("Error fetching chat messages:", error);
//       setError(error.message || "Failed to load messages");
//     } finally {
//       if (append) {
//         setLoadingMore(false);
//         setTimeout(() => {
//           if (chatContainerRef.current && previousScrollHeightRef.current) {
//             const newScrollHeight = chatContainerRef.current.scrollHeight;
//             const scrollOffset = newScrollHeight - previousScrollHeightRef.current;
//             chatContainerRef.current.scrollTop = scrollOffset;
//           }
//           shouldMaintainScrollRef.current = false;
//         }, 100);
//       } else {
//         setChatLoading(false);
//         shouldMaintainScrollRef.current = false;
//         setTimeout(() => {
//           scrollToBottom();
//         }, 200);
//       }
//     }
//   };

//   const loadMoreMessages = useCallback(async () => {
//     if (!selectedContact || loadingMore || !hasMoreMessages || chatLoading) return;
    
//     const nextPage = currentPage + 1;
//     setCurrentPage(nextPage);
//     await fetchChatMessages(selectedContact, nextPage, true);
//   }, [selectedContact, currentPage, loadingMore, hasMoreMessages, chatLoading]);

//   useEffect(() => {
//     const chatContainer = chatContainerRef.current;
//     if (!chatContainer) return;

//     let scrollTimeout = null;
    
//     const handleScroll = () => {
//       if (scrollTimeout) {
//         clearTimeout(scrollTimeout);
//       }
      
//       scrollTimeout = setTimeout(() => {
//         if (chatContainer.scrollTop <= 10 && hasMoreMessages && !loadingMore && !chatLoading) {
//           loadMoreMessages();
//         }
//       }, 200);
//     };

//     chatContainer.addEventListener('scroll', handleScroll);
//     return () => {
//       chatContainer.removeEventListener('scroll', handleScroll);
//       if (scrollTimeout) {
//         clearTimeout(scrollTimeout);
//       }
//     };
//   }, [selectedContact, hasMoreMessages, loadingMore, loadMoreMessages, chatLoading]);

//   const handleContactSelect = async (contact) => {
//     setSelectedContact(contact);
//     setReplyingTo(null);
//     setActiveMenu(null);
//     setShowEmojiPicker(false);
//     setCurrentPage(0);
//     setHasMoreMessages(true);
//     setTotalMessages(0);
//     shouldMaintainScrollRef.current = false;
//     pendingMessagesRef.current.clear();

//     // Clear locally and globally
//     updateStoredUnreadCount(contact.number, 0);
//     setContacts(prev => prev.map(c => c.id === contact.id ? { ...c, unreadCount: 0 } : c));

//     await fetchChatMessages(contact, 0, false);
//   };

//   const handleBackToContacts = () => {
//     setSelectedContact(null);
//     setReplyingTo(null);
//     setActiveMenu(null);
//   };

//   const getReplyRefId = (replyTo) => {
//     if (!replyTo) return null;
//     if (typeof replyTo === "string") return replyTo;
//     return replyTo.messageId || replyTo.wamid || null;
//   };

//   const MEDIA_TYPE_LABELS = {
//     image: "📷 Photo",
//     video: "🎥 Video",
//     audio: "🎵 Audio",
//     document: "📄 Document",
//   };

//   const getReplyPreview = (contactId, replyTo) => {
//     const refId = getReplyRefId(replyTo);
//     if (!refId) return null;

//     const list = messages[contactId] || [];
//     const original = list.find(
//       (m) => {
//         const mId = extractOriginalMessageId(m.id);
//         return mId === refId || m.id === refId || m.id === replyTo;
//       }
//     );

//     if (original) {
//       return {
//         label: original.sender === "me" ? "You" : (selectedContact?.contactName || "Customer"),
//         text: original.text || MEDIA_TYPE_LABELS[original.type] || "Media",
//         type: original.type,
//       };
//     }

//     if (typeof replyTo === "object" && replyTo?.message) {
//       return { 
//         label: "Replying to", 
//         text: replyTo.message,
//         type: replyTo.type || "text"
//       };
//     }
//     return { label: "Replying to", text: "Original message" };
//   };

//   const handleIncomingChatMessage = useCallback((contactId, rawBody) => {
//     let msg;
//     try {
//       msg = JSON.parse(rawBody);
//     } catch (e) {
//       console.error("Failed to parse chatMessages WS payload:", e, rawBody);
//       return;
//     }

//     const realId = msg.wamid || msg.messageId || null;

//     if (msg.type === "reaction" || (msg.type === "text" && msg.text && msg.text.startsWith("Reacted with"))) {
//       const reactionEmoji = msg.message || (msg.text ? msg.text.replace(/Reacted with | to your message/g, "").trim() : "👍");
//       const idToMatch = getReplyRefId(msg.replyTo);

//       if (idToMatch) {
//         setMessages((prev) => {
//           const existing = prev[contactId] || [];
//           const updated = existing.map((m) =>
//             extractOriginalMessageId(m.id) === idToMatch || m.id === idToMatch
//               ? { ...m, reaction: reactionEmoji }
//               : m
//           );
//           return { ...prev, [contactId]: updated };
//         });
//         return;
//       }
//     }

//     if (realId && pendingMessagesRef.current.has(realId)) {
//       const pending = pendingMessagesRef.current.get(realId);
      
//       setMessages((prev) => {
//         const existing = prev[contactId] || [];
//         const updated = existing.map((m) => {
//           if (m.id === pending.id || m.id === realId) {
//             return {
//               ...m,
//               id: realId,
//               status: msg.status || "delivered",
//               mediaId: msg.mediaId || m.mediaId,
//               mediaUrl: msg.mediaUrl || m.mediaUrl,
//             };
//           }
//           return m;
//         });
        
//         const tempIndex = updated.findIndex(
//           (m) => 
//             m.id.startsWith("temp-") && 
//             m.text === pending.text &&
//             m.sender === "me"
//         );
        
//         if (tempIndex !== -1 && !updated.some(m => m.id === realId)) {
//           updated[tempIndex] = {
//             ...updated[tempIndex],
//             id: realId,
//             status: msg.status || "delivered",
//             mediaId: msg.mediaId || updated[tempIndex].mediaId,
//             mediaUrl: msg.mediaUrl || updated[tempIndex].mediaUrl,
//           };
//         }
        
//         return { ...prev, [contactId]: updated };
//       });
      
//       pendingMessagesRef.current.delete(realId);
//       return;
//     }

//     let messageText = msg.message || msg.text || "";
//     const messageType = msg.type || "text";
    
//     if (messageType === "image" && !messageText) {
//       messageText = "📷 Photo";
//     } else if (messageType === "video" && !messageText) {
//       messageText = "🎥 Video";
//     } else if (messageType === "audio" && !messageText) {
//       messageText = "🎵 Audio";
//     } else if (messageType === "document" && !messageText) {
//       messageText = "📄 Document";
//     }

//     const formatted = {
//       id: realId || `ws-${Date.now()}`,
//       text: messageText,
//       sender: msg.direction === "INCOMING" ? "them" : "me",
//       time: msg.timestamp
//         ? new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
//         : new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//       timestamp: msg.timestamp || new Date().toISOString(),
//       type: messageType,
//       mediaId: msg.mediaId || null,
//       mediaUrl: msg.mediaUrl || null,
//       status: msg.status || (msg.direction === "INCOMING" ? "delivered" : "sent"),
//       replyTo: msg.replyTo || null,
//     };

//     setMessages((prev) => {
//       const existing = prev[contactId] || [];
      
//       const duplicate = existing.some(
//         (m) => 
//           extractOriginalMessageId(m.id) === realId || 
//           m.id === realId ||
//           (m.text === formatted.text && 
//            m.sender === formatted.sender &&
//            Math.abs(new Date(m.timestamp) - new Date(formatted.timestamp)) < 5000)
//       );
      
//       if (duplicate) {
//         const updated = existing.map((m) => {
//           if (extractOriginalMessageId(m.id) === realId || m.id === realId) {
//             return { ...m, status: formatted.status || m.status };
//           }
//           return m;
//         });
//         return { ...prev, [contactId]: updated };
//       }

//       return { ...prev, [contactId]: [...existing, formatted] };
//     });

//     if (formatted.sender === "them") {
//       setContacts((prev) => {
//         const newContacts = [...prev];
//         const contactIndex = newContacts.findIndex((c) => c.id === contactId);
        
//         if (contactIndex !== -1) {
//           const c = newContacts[contactIndex];
//           const isSelected = selectedContactRef.current?.id === contactId;
//           const newUnreadCount = isSelected ? 0 : (c.unreadCount || 0) + 1;
          
//           if (!isSelected) {
//             updateStoredUnreadCount(c.number, newUnreadCount);
//           }
          
//           newContacts[contactIndex] = {
//             ...c,
//             lastMessage: formatted.text || MEDIA_TYPE_LABELS[formatted.type] || `Sent a ${formatted.type}`,
//             time: formatted.timestamp,
//             unreadCount: newUnreadCount,
//           };
//         }
//         return newContacts;
//       });
//     }
//   }, [updateStoredUnreadCount]);

//   const handleStatusUpdate = useCallback((contactId, rawBody) => {
//     let data;
//     try {
//       data = JSON.parse(rawBody);
//     } catch (e) {
//       console.error("Failed to parse chatStatusUpdate WS payload:", e, rawBody);
//       return;
//     }

//     const targetId = data.messageId || data.wamid;
//     let status = (data.status || "").toLowerCase();
//     if (!targetId || !status) return;
//     if (status === "seen") status = "read";

//     setMessages((prev) => {
//       const existing = prev[contactId] || [];
//       const updated = existing.map((m) =>
//         extractOriginalMessageId(m.id) === targetId || m.id === targetId
//           ? { ...m, status }
//           : m
//       );
//       return { ...prev, [contactId]: updated };
//     });
//   }, []);

//   const subscribeToContact = useCallback(
//     (contact) => {
//       const client = stompClientRef.current;
//       if (!client || !client.connected || !contact?.number || !config.apiKey) return;

//       const msgTopic = `/topic/chatMessages/${config.apiKey}/${contact.number}`;
//       const statusTopic = `/topic/chatStatusUpdate/${config.apiKey}/${contact.number}`;

//       if (!subscriptionsRef.current[msgTopic]) {
//         subscriptionsRef.current[msgTopic] = client.subscribe(msgTopic, (frame) => {
//           handleIncomingChatMessage(contact.id, frame.body);
//         });
//       }

//       if (!subscriptionsRef.current[statusTopic]) {
//         subscriptionsRef.current[statusTopic] = client.subscribe(statusTopic, (frame) => {
//           handleStatusUpdate(contact.id, frame.body);
//         });
//       }
//     },
//     [config.apiKey, handleIncomingChatMessage, handleStatusUpdate]
//   );

//   useEffect(() => {
//     if (!isConfigLoaded || !config.apiKey) return;

//     const client = new Client({
//       brokerURL: WS_URL,
//       reconnectDelay: 5000,
//       heartbeatIncoming: 10000,
//       heartbeatOutgoing: 10000,
//       onConnect: () => {
//         setWsConnected(true);
//         contactsRef.current.forEach(subscribeToContact);
//       },
//       onDisconnect: () => {
//         setWsConnected(false);
//       },
//       onWebSocketClose: () => {
//         setWsConnected(false);
//       },
//     });

//     stompClientRef.current = client;
//     client.activate();

//     return () => {
//       Object.values(subscriptionsRef.current).forEach((sub) => {
//         try {
//           sub.unsubscribe();
//         } catch (_) { }
//       });
//       subscriptionsRef.current = {};
//       client.deactivate();
//       stompClientRef.current = null;
//       setWsConnected(false);
//     };
//   }, [isConfigLoaded, config.apiKey, subscribeToContact]);

//   useEffect(() => {
//     contactsRef.current = contacts;
//     if (stompClientRef.current?.connected) {
//       contacts.forEach(subscribeToContact);
//     }
//   }, [contacts, subscribeToContact]);

//   const handleSendMessage = async () => {
//     if ((!newMessage.trim() && !selectedFile) || !selectedContact || sending) return;

//     setShowEmojiPicker(false);

//     const tempId = `temp-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
    
//     let replyText = "";
//     if (replyingTo) {
//       replyText = replyingTo.text || MEDIA_TYPE_LABELS[replyingTo.type] || "Media";
//     }
    
//     const tempMsg = {
//       id: tempId,
//       text: newMessage || (selectedFile ? `📎 ${fileType}` : ""),
//       sender: "me",
//       time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
//       timestamp: new Date().toISOString(),
//       type: fileType,
//       mediaUrl: selectedFile ? URL.createObjectURL(selectedFile) : null,
//       status: "sending",
//       replyTo: replyingTo ? { 
//         messageId: replyingTo.id, 
//         message: replyText, 
//         type: replyingTo.type || "text",
//         sender: replyingTo.sender
//       } : null,
//     };

//     pendingMessagesRef.current.set(tempId, {
//       ...tempMsg,
//       contactId: selectedContact.id,
//     });

//     setMessages((prev) => ({
//       ...prev,
//       [selectedContact.id]: [...(prev[selectedContact.id] || []), tempMsg],
//     }));

//     setContacts(prev => prev.map(c => 
//       c.id === selectedContact.id 
//         ? { ...c, time: tempMsg.timestamp, lastMessage: tempMsg.text || `Sent a ${fileType}` } 
//         : c
//     ));

//     const messageToSend = newMessage;
//     const fileToSend = selectedFile;
//     const currentFileType = fileType;
//     const replyMessageId = replyingTo ? extractOriginalMessageId(replyingTo.id) : null;

//     setNewMessage("");
//     setSelectedFile(null);
//     setFileType("text");
//     setReplyingTo(null);

//     try {
//       setSending(true);
//       const formData = new FormData();
//       formData.append("apiKey", config.apiKey);
//       formData.append("to", selectedContact.number);
      
//       if (messageToSend) {
//         formData.append("message", messageToSend);
//       } else if (fileToSend) {
//         formData.append("message", `Sent a ${currentFileType}`);
//       }
      
//       if (currentFileType) formData.append("type", currentFileType);

//       if (replyMessageId) {
//         formData.append("replyMessageId", replyMessageId);
//       }

//       if (fileToSend && currentFileType !== "text") {
//         formData.append("file", fileToSend);
//       }

//       const response = await fetch(`${API_URL}/api/whatsapp-chat/reply`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });

//       const responseData = await response.json();

//       if (!response.ok || responseData.status !== "success") {
//         throw new Error(responseData.message || "Failed to send message");
//       }

//       setMessages((prev) => {
//         const existing = prev[selectedContact.id] || [];
//         const updated = existing.map((m) =>
//           m.id === tempId ? { ...m, status: "sent" } : m
//         );
//         return { ...prev, [selectedContact.id]: updated };
//       });

//       if (responseData.wamid || responseData.messageId) {
//         const realId = responseData.wamid || responseData.messageId;
        
//         const pending = pendingMessagesRef.current.get(tempId);
//         if (pending) {
//           pendingMessagesRef.current.delete(tempId);
//           pendingMessagesRef.current.set(realId, {
//             ...pending,
//             id: realId,
//           });
//         }
        
//         setMessages((prev) => {
//           const existing = prev[selectedContact.id] || [];
//           const updated = existing.map((m) =>
//             m.id === tempId ? { ...m, id: realId, status: "sent" } : m
//           );
//           return { ...prev, [selectedContact.id]: updated };
//         });
//       }
//     } catch (error) {
//       console.error("Failed to send message:", error);
      
//       pendingMessagesRef.current.delete(tempId);
      
//       setMessages((prev) => ({
//         ...prev,
//         [selectedContact.id]: (prev[selectedContact.id] || []).filter((msg) => msg.id !== tempId),
//       }));
      
//       alert("Failed to send message. Please try again.");
//     } finally {
//       setSending(false);
//     }
//   };

//   const handleReactToMessage = async (messageToReact, emoji) => {
//     setActiveMenu(null);
//     if (!selectedContact) return;

//     setMessages((prev) => {
//       const existing = prev[selectedContact.id] || [];
//       const updated = existing.map(m => m.id === messageToReact.id ? { ...m, reaction: emoji } : m);
//       return { ...prev, [selectedContact.id]: updated };
//     });

//     try {
//       const formData = new FormData();
//       formData.append("apiKey", config.apiKey);
//       formData.append("to", selectedContact.number);
//       formData.append("message", emoji);
//       formData.append("type", "reaction");
//       formData.append("replyMessageId", extractOriginalMessageId(messageToReact.id));

//       await fetch(`${API_URL}/api/whatsapp-chat/reply`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });
//     } catch (err) {
//       console.error("Failed to send reaction:", err);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSendMessage();
//     }
//   };

//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setSelectedFile(file);
//     if (file.type.startsWith("image/")) setFileType("image");
//     else if (file.type.startsWith("video/")) setFileType("video");
//     else if (file.type.startsWith("audio/")) setFileType("audio");
//     else setFileType("document");
//   };

//   const handleRemoveFile = () => {
//     setSelectedFile(null);
//     setFileType("text");
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   };

//   const toggleMenu = (e, msgId) => {
//     e.stopPropagation();
//     if (activeMenu?.id === msgId) {
//       setActiveMenu(null);
//     } else {
//       const rect = e.currentTarget.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - rect.bottom;
//       const direction = spaceBelow < 220 ? 'up' : 'down';
//       setActiveMenu({ id: msgId, direction });
//     }
//   };

//   const getMenuIcon = (type) => {
//     switch (type) {
//       case 'info': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4m0-4h.01" /></svg>;
//       case 'reply': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" /></svg>;
//       case 'copy': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" /></svg>;
//       case 'react': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" /></svg>;
//       case 'forward': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10h-10a8 8 0 00-8 8v2M21 10l-6 6m6-6l-6-6" /></svg>;
//       case 'pin': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v6m-4 4l8-8M4 14l8-8m-4 12l2 4 2-4" /></svg>;
//       case 'ai': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zM12 6v6l4 2" /></svg>;
//       case 'star': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1 3-6z" /></svg>;
//       case 'delete': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" /></svg>;
//       default: return null;
//     }
//   };

//   const renderMessageWithReplies = (message, index) => {
//     const previousMessage = messages[selectedContact.id]?.[index - 1];
//     const showDateSeparator = shouldShowDateSeparator(message, previousMessage);
//     const isReply = !!message.replyTo;
//     const replyPreview = isReply ? getReplyPreview(selectedContact.id, message.replyTo) : null;
//     const isMenuOpen = activeMenu?.id === message.id;
//     const isSending = message.status === "sending";

//     const menuPositionClasses = activeMenu?.direction === 'up'
//       ? `bottom-full mb-1 ${message.sender === 'me' ? 'origin-bottom-right right-0' : 'origin-bottom-left left-0'}`
//       : `top-8 ${message.sender === 'me' ? 'origin-top-right right-0' : 'origin-top-left left-0'}`;

//     return (
//       <div key={message.id} id={`message-${message.id}`} className="relative">
//         {showDateSeparator && <DateSeparator date={formatMessageDate(message.timestamp)} />}

//         <motion.div
//           initial={{ opacity: 0, y: 10 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.3 }}
//           className={`flex ${message.sender === "me" ? "justify-end" : "justify-start"} mb-4`}
//         >
//           <div className="relative group max-w-[85%] md:max-w-md flex flex-col">
//             <div
//               className={`px-3 py-2 rounded-xl shadow-sm relative ${message.sender === "me"
//                 ? `bg-[#dcf8c6] dark:bg-[#056162] text-gray-900 dark:text-white rounded-tr-none ${isSending ? 'opacity-70' : ''}`
//                 : "bg-white dark:bg-[#202c33] text-gray-900 dark:text-white rounded-tl-none border border-gray-100 dark:border-gray-800"
//                 }`}
//             >
//               <button
//                 onClick={(e) => toggleMenu(e, message.id)}
//                 className={`menu-trigger-btn absolute top-0 right-0 m-1 p-0.5 rounded-full text-gray-500 dark:text-gray-300 shadow-sm opacity-0 group-hover:opacity-100 transition-opacity z-20 ${isMenuOpen ? 'opacity-100 bg-white dark:bg-[#202c33]' : 'bg-white/80 dark:bg-[#202c33]/80 backdrop-blur-sm'
//                   }`}
//               >
//                 <svg viewBox="0 0 18 18" width="18" height="18" fill="currentColor">
//                   <path d="M3.3 5.3l5.7 5.7 5.7-5.7 1.6 1.6-7.3 7.2-7.3-7.2 1.6-1.6z"></path>
//                 </svg>
//               </button>

//               {isMenuOpen && (
//                 <div className={`message-menu-container absolute ${menuPositionClasses} w-52 bg-white dark:bg-[#233138] rounded-xl shadow-xl border border-gray-200 dark:border-[#323d43] z-50 flex flex-col transform transition-transform`}>
//                   <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200 dark:border-[#323d43]">
//                     {['👍', '❤️', '😂', '😮', '😢', '🙏'].map(emoji => (
//                       <button
//                         key={emoji}
//                         onClick={(e) => { e.stopPropagation(); handleReactToMessage(message, emoji); }}
//                         className="text-xl hover:scale-125 transition-transform"
//                       >
//                         {emoji}
//                       </button>
//                     ))}
//                   </div>
//                   <div className="flex flex-col py-1 overflow-hidden">
//                     {[
//                       { id: 'info', label: 'Message info' },
//                       {
//                         id: 'reply', label: 'Reply', action: () => {
//                           setActiveMenu(null);
//                           setReplyingTo(message);
//                           setTimeout(() => inputRef.current?.focus(), 50);
//                         }
//                       }, { id: 'copy', label: 'Copy', action: () => { setActiveMenu(null); navigator.clipboard.writeText(message.text || ''); } },
//                       { id: 'forward', label: 'Forward' },
//                       { id: 'delete', label: 'Delete' }
//                     ].map(option => (
//                       <button
//                         key={option.id}
//                         onClick={(e) => { e.stopPropagation(); if (option.action) option.action(); }}
//                         className="w-full text-left px-4 py-2.5 hover:bg-gray-100 dark:hover:bg-[#182229] flex items-center space-x-4 text-[15px] text-gray-800 dark:text-[#d1d7db] transition-colors"
//                       >
//                         <span className="flex justify-center text-gray-500 dark:text-[#8696a0]">{getMenuIcon(option.id)}</span>
//                         <span>{option.label}</span>
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {isReply && replyPreview && (
//                 <div
//                   className="mb-2 p-2 bg-black/5 dark:bg-black/20 rounded-lg border-l-4 border-green-500 flex flex-col cursor-pointer"
//                   onClick={() => {
//                     const refId = getReplyRefId(message.replyTo);
//                     if (refId) {
//                       const target = document.querySelector(`[id$="${refId}"]`) || document.getElementById(`message-${refId}`);
//                       target?.scrollIntoView({ behavior: "smooth", block: "center" });
//                     }
//                   }}
//                 >
//                   <span className="text-xs font-semibold text-green-600 dark:text-green-400 mb-1">
//                     {replyPreview?.label || "Replying to"}
//                   </span>
//                   <p className="text-sm text-gray-700 dark:text-gray-300 truncate opacity-90">
//                     {replyPreview?.text || "Media"}
//                   </p>
//                 </div>
//               )}

//               <LazyMediaContent message={message} getMediaSrc={getMediaSrc} />

//               {message.text && message.type === "text" && (
//                 <p className="text-[15px] leading-relaxed break-words whitespace-pre-wrap">{message.text}</p>
//               )}

//               <div className="flex justify-end items-center mt-1 space-x-1">
//                 <p className="text-[11px] text-gray-500 dark:text-gray-400/80">
//                   {message.time}
//                 </p>
//                 {message.sender === "me" && (
//                   <div className="ml-1">
//                     {message.status === "sending" && (
//                       <div className="w-3 h-3 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
//                     )}
//                     {message.status === "sent" && <FontAwesomeIcon icon={faCheck} className="text-gray-400 text-[11px]" />}
//                     {message.status === "delivered" && <FontAwesomeIcon icon={faCheckDouble} className="text-gray-400 text-[11px]" />}
//                     {message.status === "read" && <FontAwesomeIcon icon={faCheckDouble} className="text-blue-500 text-[11px]" />}
//                     {message.status === "failed" && <span className="text-red-500 text-[11px]">!</span>}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {message.reaction && (
//               <div
//                 className={`absolute -bottom-3 ${message.sender === 'me' ? 'right-2' : 'left-2'} bg-white dark:bg-[#2a3942] border border-gray-200 dark:border-[#111b21] rounded-full px-1.5 py-0.5 text-[13px] shadow-sm z-10 flex items-center justify-center`}
//               >
//                 {message.reaction}
//               </div>
//             )}
//           </div>
//         </motion.div>
//       </div>
//     );
//   };

//   const filteredContacts = contacts
//     .filter((contact) =>
//       (contact.contactName && contact.contactName.toLowerCase().includes(searchQuery.toLowerCase())) ||
//       (contact.number && contact.number.includes(searchQuery))
//     )
//     .sort((a, b) => {
//       const dateA = a.time ? new Date(a.time).getTime() : 0;
//       const dateB = b.time ? new Date(b.time).getTime() : 0;
//       return dateB - dateA;
//     });

//   return (
//     <div className="flex h-[93vh] bg-[#f0f2f5] dark:bg-[#111b21] font-sans">
//       <div
//         className={`${isMobileView && selectedContact ? "hidden" : "flex"
//           } w-full md:w-[350px] lg:w-[400px] bg-white dark:bg-[#111b21] border-r border-gray-200 dark:border-gray-800 flex-col z-10`}
//       >
//         <div className="bg-[#f0f2f5] dark:bg-[#202c33] p-4 flex justify-between items-center h-16">
//           <div className="flex items-center gap-2">
//             <img src={Image1} alt="Logo" className="w-6 h-6 object-contain rounded-sm" />
//             <h1 className="text-[15px] font-semibold text-gray-800 dark:text-[#e9edef]">Powered by Nipane</h1>
//             <span
//               title={wsConnected ? "Live" : "Reconnecting..."}
//               className={`w-2 h-2 ml-1 rounded-full ${wsConnected ? "bg-green-500" : "bg-gray-400 animate-pulse"}`}
//             />
//           </div>
//           <button onClick={fetchUniqueSenders} className="p-2 text-gray-600 dark:text-[#aebac1] bg-transparent outline-none border-none">
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//             </svg>
//           </button>
//         </div>

//         <div className="p-2 bg-white dark:bg-[#111b21]">
//           <div className="bg-[#f0f2f5] dark:bg-[#202c33] rounded-lg flex items-center px-3 py-1.5">
//             <svg className="h-5 w-5 text-gray-500 dark:text-[#aebac1]" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
//             </svg>
//             <input
//               type="text"
//               placeholder="Search or start new chat"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="w-full bg-transparent border-none focus:ring-0 text-sm text-gray-800 dark:text-[#e9edef] placeholder-gray-500 px-3 py-1 outline-none"
//             />
//           </div>
//         </div>

//         <div className="flex-1 overflow-y-auto">
//           {error ? (
//             <div className="p-4 text-center text-red-500 text-sm">{error}</div>
//           ) : loading ? (
//             <div className="p-4 text-center text-gray-500 text-sm">Syncing chats...</div>
//           ) : filteredContacts.map((contact) => (
//             <div
//               key={contact.id}
//               className={`flex items-center px-4 py-3 cursor-pointer border-b border-gray-100 dark:border-[#202c33]/50 transition-colors ${selectedContact?.id === contact.id ? "bg-[#f0f2f5] dark:bg-[#2a3942]" : "hover:bg-[#f5f6f6] dark:hover:bg-[#202c33]"
//                 }`}
//               onClick={() => handleContactSelect(contact)}
//             >
//               <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-medium text-lg ${getAvatarColor(contact.contactName)}`}>
//                 {getAvatarInitials(contact.contactName)}
//               </div>
//               <div className="ml-4 flex-1 min-w-0">
//                 <div className="flex justify-between items-baseline">
//                   <h2 className="text-[17px] font-normal text-gray-900 dark:text-[#e9edef] truncate">{contact.contactName}</h2>
//                   {contact.time && (
//                     <span className="text-[12px] text-gray-500 dark:text-[#8696a0] ml-2 shrink-0">
//                       {formatSidebarTime(contact.time)}
//                     </span>
//                   )}
//                 </div>
//                 <div className="flex justify-between items-center mt-0.5">
//                   <p className="text-[13px] text-gray-500 dark:text-[#8696a0] truncate">{contact.lastMessage || 'Tap to view chat'}</p>
//                   {contact.unreadCount > 0 && (
//                     <span className="bg-[#00a884] text-white text-[11px] font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center ml-2 shadow-sm">
//                       {contact.unreadCount}
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           ))}
//           {filteredContacts.length === 0 && !loading && (
//             <div className="p-4 text-center text-gray-500 text-sm">No chats found.</div>
//           )}
//         </div>
//       </div>

//       <div className={`${isMobileView && !selectedContact ? "hidden" : "flex"} flex-1 flex-col relative`}>
//         {selectedContact ? (
//           <>
//             <div className="bg-[#f0f2f5] dark:bg-[#202c33] px-4 py-2.5 flex items-center h-16 z-20">
//               {isMobileView && (
//                 <button onClick={handleBackToContacts} className="mr-3 text-gray-600 dark:text-gray-300 bg-transparent outline-none border-none">
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
//                 </button>
//               )}
//               <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white ${getAvatarColor(selectedContact.contactName)}`}>
//                 {getAvatarInitials(selectedContact.contactName)}
//               </div>
//               <div className="ml-4">
//                 <h2 className="text-[16px] font-medium text-gray-900 dark:text-[#e9edef]">
//                   {selectedContact.contactName}
//                 </h2>
//                 <p className="text-[13px] text-gray-500 dark:text-[#8696a0]">
//                   +{selectedContact.number} • Business Account
//                 </p>
//               </div>
//             </div>

//             <div className="flex-1 relative bg-[#efeae2] dark:bg-[#0b141a]">
//               <div
//                 className="absolute inset-0 z-0 opacity-[0.65] dark:opacity-[0.25] mix-blend-multiply dark:mix-blend-overlay pointer-events-none"
//                 style={{
//                   backgroundImage: `url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')`,
//                   backgroundRepeat: 'repeat',
//                   backgroundSize: '400px',
//                   backgroundPosition: 'center'
//                 }}
//               />
//               <div className="absolute inset-0 z-10 overflow-y-auto p-4 chat-messages-container" ref={chatContainerRef}>
//                 {chatLoading ? (
//                   <div className="flex justify-center items-center h-full">
//                     <span className="text-sm text-gray-500 bg-white dark:bg-gray-800 px-4 py-2 rounded-full shadow-sm">Loading messages...</span>
//                   </div>
//                 ) : (
//                   <div className="space-y-1">
//                     {loadingMore && (
//                       <div className="flex justify-center py-4">
//                         <div className="flex items-center space-x-2 text-sm text-gray-500 bg-white dark:bg-gray-800 px-4 py-2 rounded-full shadow-sm">
//                           <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-gray-500"></div>
//                           <span>Loading older messages...</span>
//                         </div>
//                       </div>
//                     )}
                    
//                     {!hasMoreMessages && messages[selectedContact.id]?.length > 0 && (
//                       <div className="flex justify-center py-4">
//                         <span className="text-xs text-gray-400 bg-white dark:bg-gray-800 px-3 py-1 rounded-full shadow-sm">
//                           No more messages to load
//                         </span>
//                       </div>
//                     )}
                    
//                     {totalMessages > 0 && messages[selectedContact.id]?.length > 0 && (
//                       <div className="flex justify-center py-2">
//                         <span className="text-xs text-gray-400 bg-white dark:bg-gray-800 px-3 py-1 rounded-full shadow-sm">
//                           Showing {messages[selectedContact.id]?.length || 0} of {totalMessages} messages
//                         </span>
//                       </div>
//                     )}
                    
//                     <AnimatePresence>
//                       {messages[selectedContact.id]?.map((message, index) => renderMessageWithReplies(message, index))}
//                     </AnimatePresence>
//                     <div ref={messagesEndRef} className="h-4" />
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="bg-[#f0f2f5] dark:bg-[#202c33] px-4 py-3 flex flex-col justify-end z-20 relative">
//               {replyingTo && (
//                 <div className="mb-2 p-3 bg-white dark:bg-[#2a3942] border-l-4 border-[#00a884] rounded-lg shadow-sm flex items-center justify-between">
//                   <div className="flex-1 min-w-0">
//                     <p className="text-[13px] font-semibold text-[#00a884]">
//                       Replying to {replyingTo.sender === 'me' ? 'yourself' : selectedContact?.contactName}
//                     </p>
//                     <p className="text-[13px] text-gray-600 dark:text-gray-300 truncate">
//                       {replyingTo.text || MEDIA_TYPE_LABELS[replyingTo.type] || 'Media'}
//                     </p>
//                   </div>
//                   <button onClick={() => setReplyingTo(null)} className="text-gray-500 hover:text-gray-700 dark:text-gray-400 bg-transparent outline-none border-none ml-3 flex-shrink-0">
//                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                     </svg>
//                   </button>
//                 </div>
//               )}

//               {selectedFile && (
//                 <div className="mb-2 p-3 bg-white dark:bg-[#2a3942] rounded-lg shadow-sm flex items-center justify-between border border-gray-200 dark:border-gray-700">
//                   <div className="flex items-center">
//                     {fileType === "image" ? (
//                       <img src={URL.createObjectURL(selectedFile)} alt="Preview" className="h-10 w-10 object-cover rounded" />
//                     ) : fileType === "audio" ? (
//                       <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">🎵</div>
//                     ) : fileType === "video" ? (
//                       <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">🎥</div>
//                     ) : (
//                       <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">📄</div>
//                     )}
//                     <span className="ml-3 text-sm text-gray-700 dark:text-gray-300 truncate max-w-[200px]">{selectedFile.name}</span>
//                   </div>
//                   <button onClick={handleRemoveFile} className="text-white bg-transparent outline-none border-none ml-3">
//                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                     </svg>
//                   </button>
//                 </div>
//               )}

//               {showEmojiPicker && (
//                 <div className="absolute bottom-[65px] left-4 z-50 shadow-2xl rounded-lg border border-gray-200 dark:border-gray-700">
//                   <EmojiPicker
//                     onEmojiClick={(emojiObject) => {
//                       setNewMessage((prev) => prev + emojiObject.emoji);
//                     }}
//                     theme="auto"
//                   />
//                 </div>
//               )}

//               <div className="flex items-center space-x-2 w-full">
//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   onChange={handleFileSelect}
//                   accept=".jpg,.jpeg,.png,.gif,.mp4,.3gp,.pdf,.doc,.docx,.txt,.mp3,.ogg,.opus,.aac,.wav"
//                   className="hidden"
//                 />

//                 <button
//                   onClick={() => fileInputRef.current?.click()}
//                   className="p-2 text-gray-500 dark:text-[#aebac1] bg-transparent hover:bg-black/5 dark:hover:bg-white/5 rounded-full transition-colors outline-none border-none"
//                 >
//                   <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
//                     <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
//                   </svg>
//                 </button>

//                 <button
//                   onClick={() => setShowEmojiPicker(!showEmojiPicker)}
//                   className={`p-2 bg-transparent rounded-full transition-colors outline-none border-none ${showEmojiPicker ? "text-[#00a884] bg-black/5 dark:bg-white/5" : "text-gray-500 dark:text-[#aebac1] hover:bg-black/5 dark:hover:bg-white/5"}`}
//                 >
//                   <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
//                     <path d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"></path>
//                   </svg>
//                 </button>

//                 <div className="flex-1 bg-white dark:bg-[#2a3942] rounded-xl overflow-hidden shadow-sm flex items-center">
//                   <input
//                     type="text"
//                     ref={inputRef}
//                     value={newMessage}
//                     onChange={(e) => setNewMessage(e.target.value)}
//                     onKeyPress={handleKeyPress}
//                     placeholder="Type a message"
//                     disabled={sending}
//                     className="w-full bg-transparent border-none focus:ring-0 py-2.5 px-4 text-[15px] text-gray-900 dark:text-[#e9edef] placeholder-gray-500 dark:placeholder-[#8696a0] outline-none"
//                   />
//                 </div>

//                 {(newMessage.trim() || selectedFile) && (
//                   <button
//                     onClick={handleSendMessage}
//                     disabled={sending}
//                     className={`px-5 py-2 rounded-full font-medium flex items-center justify-center transition-colors outline-none border-none text-[15px] ${!sending
//                       ? "bg-[#00a884] text-white hover:bg-[#008f6f]"
//                       : "bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
//                       }`}
//                   >
//                     {sending ? "Sending..." : "Send"}
//                   </button>
//                 )}
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="flex-1 flex flex-col items-center justify-center bg-[#f0f2f5] dark:bg-[#111b21] relative">
//             <div
//               className="absolute inset-0 z-0 opacity-[0.55] dark:opacity-[0.2] mix-blend-multiply dark:mix-blend-overlay pointer-events-none"
//               style={{
//                 backgroundImage: `url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')`,
//                 backgroundRepeat: 'repeat',
//                 backgroundSize: '400px',
//                 backgroundPosition: 'center'
//               }}
//             />
//             <div className="relative z-10 flex flex-col items-center">
//               <h2 className="text-3xl font-light text-gray-700 dark:text-[#e9edef] mt-8 mb-4">WhatsApp Web</h2>
//               <p className="text-sm text-gray-700 dark:text-[#8696a0] max-w-md text-center dark:bg-black/40 px-4 py-2 rounded-lg backdrop-blur-sm">
//                 Send and receive messages without keeping your phone online.<br />
//                 Select a contact from the sidebar to view your conversation.
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const LazyMediaContent = ({ message, getMediaSrc }) => {
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [loadFailed, setLoadFailed] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [src, setSrc] = useState(null);

//   if (!message.mediaUrl && !message.mediaId) return null;

//   const handleMediaClick = () => {
//     if (isLoaded) {
//       setIsModalOpen(true);
//       return;
//     }
    
//     setIsLoading(true);
//     const mediaSrc = getMediaSrc(message);
    
//     if (!mediaSrc) {
//       setIsLoading(false);
//       setLoadFailed(true);
//       return;
//     }
    
//     setSrc(mediaSrc);
    
//     if (message.type === "image") {
//       const img = new Image();
//       img.onload = () => {
//         setIsLoaded(true);
//         setIsLoading(false);
//         setIsModalOpen(true);
//       };
//       img.onerror = () => {
//         setIsLoading(false);
//         setLoadFailed(true);
//       };
//       img.src = mediaSrc;
//     } else {
//       setIsLoaded(true);
//       setIsLoading(false);
//       setIsModalOpen(true);
//     }
//   };

//   if (!isLoaded && !isLoading && !loadFailed) {
//     return (
//       <button
//         onClick={handleMediaClick}
//         className="mt-2 w-full p-4 bg-black/5 dark:bg-black/20 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 hover:border-green-500 dark:hover:border-green-400 transition-all duration-200 flex flex-col items-center justify-center gap-2"
//       >
//         <span className="text-3xl">
//           {message.type === "image" && "🖼️"}
//           {message.type === "video" && "🎥"}
//           {message.type === "audio" && "🎵"}
//           {message.type === "document" && "📄"}
//         </span>
//         <span className="text-sm text-gray-600 dark:text-gray-300 font-medium">
//           {message.type === "image" && "Tap to view photo"}
//           {message.type === "video" && "Tap to play video"}
//           {message.type === "audio" && "Tap to play audio"}
//           {message.type === "document" && "Tap to view document"}
//         </span>
//         <span className="text-xs text-gray-400 dark:text-gray-500">
//           Click to load
//         </span>
//       </button>
//     );
//   }

//   if (isLoading) {
//     return (
//       <div className="mt-2 p-4 bg-black/5 dark:bg-black/20 rounded-lg flex flex-col items-center justify-center gap-2">
//         <div className="animate-spin rounded-full h-8 w-8 border-4 border-green-500 border-t-transparent"></div>
//         <span className="text-sm text-gray-500 dark:text-gray-400">Loading media...</span>
//       </div>
//     );
//   }

//   if (loadFailed) {
//     return (
//       <div className="mt-2 p-4 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
//         <p className="text-sm text-red-600 dark:text-red-400">Failed to load media</p>
//         <button
//           onClick={handleMediaClick}
//           className="mt-2 text-sm text-blue-500 hover:text-blue-400"
//         >
//           Try again
//         </button>
//       </div>
//     );
//   }

//   const renderMedia = () => {
//     if (message.type === "image") {
//       return (
//         <img
//           src={src}
//           alt="Shared content"
//           className="max-w-full rounded-lg max-h-64 object-contain cursor-pointer hover:opacity-90 transition-opacity"
//           onClick={() => setIsModalOpen(true)}
//           onError={() => {
//             setLoadFailed(true);
//             setIsLoaded(false);
//           }}
//         />
//       );
//     }

//     if (message.type === "video") {
//       return (
//         <video
//           controls
//           preload="metadata"
//           className="max-w-full rounded-lg max-h-64 object-contain"
//           onError={() => {
//             setLoadFailed(true);
//             setIsLoaded(false);
//           }}
//         >
//           <source src={src} />
//           Your browser doesn't support embedded videos.
//         </video>
//       );
//     }

//     if (message.type === "audio") {
//       return (
//         <audio
//           controls
//           preload="metadata"
//           className="w-full h-10"
//           onError={() => {
//             setLoadFailed(true);
//             setIsLoaded(false);
//           }}
//         >
//           <source src={src} />
//           Your browser doesn't support the audio element.
//         </audio>
//       );
//     }

//     if (message.type === "document") {
//       return (
//         <a
//           href={src}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="flex items-center gap-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg text-blue-500 hover:text-blue-400 font-medium text-sm"
//         >
//           📄 Open Document
//         </a>
//       );
//     }

//     return null;
//   };

//   return (
//     <>
//       <div className="mt-2">
//         {renderMedia()}
//       </div>

//       {isModalOpen && message.type === "image" && (
//         <div
//           className="fixed z-[100] bg-black/95 flex items-center justify-center p-4 cursor-pointer"
//           onClick={() => setIsModalOpen(false)}
//         >
//           <button
//             className="absolute top-6 right-6 text-white text-4xl opacity-80 hover:opacity-100 font-light z-50 outline-none"
//             onClick={() => setIsModalOpen(false)}
//           >
//             &times;
//           </button>
//           <img
//             src={src}
//             alt="Expanded content"
//             className="max-w-full max-h-full object-contain cursor-default"
//             onClick={(e) => e.stopPropagation()}
//             onError={() => {
//               setLoadFailed(true);
//               setIsLoaded(false);
//               setIsModalOpen(false);
//             }}
//           />
//         </div>
//       )}
//     </>
//   );
// };

// export default Chat;



import { useState, useEffect, useRef, useContext, useCallback } from "react";
import { Client } from "@stomp/stompjs";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import EmojiPicker from "emoji-picker-react";
import Image1 from "../../assets/logoo.png"

const WS_URL = "wss://waws.deetyasoft.com/sendMessage";

const toMs = (v) => {
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? 0 : t;
};

const Chat = () => {
  const [config, setConfig] = useState({ apiKey: "", baseUrl: "", domain: "" });
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [messages, setMessages] = useState({});
  const [newMessage, setNewMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [chatLoading, setChatLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileType, setFileType] = useState("text");
  const [replyingTo, setReplyingTo] = useState(null);
  const [wsConnected, setWsConnected] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalMessages, setTotalMessages] = useState(0);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const [activeMenu, setActiveMenu] = useState(null);

  const fileInputRef = useRef(null);
  const messagesEndRef = useRef(null);
  const handledNotifRef = useRef(null);
  const inputRef = useRef(null);
  const chatContainerRef = useRef(null);
  
  const previousScrollHeightRef = useRef(0);
  const shouldMaintainScrollRef = useRef(false);
  
  const pendingMessagesRef = useRef(new Map());
  
  const stompClientRef = useRef(null);
  const subscriptionsRef = useRef({});
  const contactsRef = useRef([]);
  const selectedContactRef = useRef(null);

  const { user } = useContext(AuthContext);
  const token = user?.token || localStorage.getItem("token");
  const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

  // Local Storage functions for syncing Unread Messages globally
  const getStoredUnreadCounts = useCallback(() => {
    try {
      return JSON.parse(localStorage.getItem(`wa_unread_${companyId}`) || "{}");
    } catch {
      return {};
    }
  }, [companyId]);

  const updateStoredUnreadCount = useCallback((number, count) => {
    const stored = getStoredUnreadCounts();
    if (count <= 0) {
      delete stored[number];
    } else {
      stored[number] = count;
    }
    localStorage.setItem(`wa_unread_${companyId}`, JSON.stringify(stored));
    window.dispatchEvent(new Event("wa_unread_changed"));
  }, [companyId, getStoredUnreadCounts]);

  // Persisted "last message" per contact (survives refresh / logout)
  const getStoredLastMessages = useCallback(() => {
    try {
      return JSON.parse(localStorage.getItem(`wa_last_${companyId}`) || "{}") || {};
    } catch {
      return {};
    }
  }, [companyId]);

  const saveLastMessage = useCallback((number, entry) => {
    if (!number) return;
    const map = getStoredLastMessages();
    if (map[number] && toMs(map[number].timestamp) > toMs(entry.timestamp)) return;
    map[number] = entry;
    localStorage.setItem(`wa_last_${companyId}`, JSON.stringify(map));
    window.dispatchEvent(new Event("wa_last_changed"));
  }, [companyId, getStoredLastMessages]);

  // Marks a chat as read: stores the "read up to" time (used to count messages that
  // arrive while logged out) and clears the unread badge.
  const markContactRead = useCallback((number, timestamp) => {
    if (!number) return;
    try {
      const key = `wa_lastread_${companyId}`;
      const map = JSON.parse(localStorage.getItem(key) || "{}") || {};
      const next = toMs(timestamp) || Date.now();
      if (next > toMs(map[number])) {
        map[number] = new Date(next).toISOString();
        localStorage.setItem(key, JSON.stringify(map));
      }
    } catch (e) { /* ignore */ }
    updateStoredUnreadCount(number, 0);
  }, [companyId, updateStoredUnreadCount]);

  const getAvatarInitials = (name) => {
    if (!name) return "U";
    return String(name).charAt(0).toUpperCase();
  };

  const getAvatarColor = (name) => {
    const colors = [
      "bg-red-500", "bg-blue-500", "bg-green-500", "bg-yellow-500",
      "bg-purple-500", "bg-pink-500", "bg-indigo-500", "bg-teal-500", "bg-orange-500"
    ];
    if (!name) return colors[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const buildApiUrl = (endpoint) => {
    const d = (config.domain || "").replace(/\/+$/, "");
    const b = (config.baseUrl || "").replace(/^\/+|\/+$/g, "");
    const e = (endpoint || "").replace(/^\/+/, "");

    let finalUrl = d;
    if (b) finalUrl += `/${b}`;
    if (e) finalUrl += `/${e}`;

    return finalUrl;
  };

  const getMediaSrc = (message) => {
    if (message.mediaUrl) return message.mediaUrl;
    if (message.mediaId) {
      return `https://waapi.deetyasoft.com/api/lms/whatsapp-config/media?apiKey=${config.apiKey}&mediaId=${message.mediaId}`;
    }
    return null;
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(`${API_URL}/api/whatsappConfig/${companyId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const result = await response.json();

        if (response.ok && result.status === "success" && result.data) {
          setConfig({
            apiKey: result.data.apiKey || "",
            baseUrl: result.data.baseUrl || "",
            domain: result.data.domain || "",
          });
          setIsConfigLoaded(true);
        } else {
          setError("WhatsApp configuration not found. Please set it up in settings.");
          setLoading(false);
        }
      } catch (err) {
        console.error("Failed to load WhatsApp configuration:", err);
        setError("Failed to load WhatsApp API configuration.");
        setLoading(false);
      }
    };

    if (companyId) {
      fetchConfig();
    }
  }, [companyId, token]);

  useEffect(() => {
    const checkScreenSize = () => setIsMobileView(window.innerWidth <= 768);
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.message-menu-container') && !e.target.closest('.menu-trigger-btn')) {
        setActiveMenu(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const scrollToBottom = () => {
    if (!shouldMaintainScrollRef.current) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  useEffect(() => {
    if (!loadingMore && !chatLoading) {
      scrollToBottom();
    }
  }, [messages, selectedContact, loadingMore, chatLoading]);

  useEffect(() => {
    selectedContactRef.current = selectedContact;
  }, [selectedContact]);

  // The Sidebar's global listener skips unread counting for the chat that is open
  useEffect(() => {
    window.__waActiveContact = selectedContact?.number || null;
    return () => {
      window.__waActiveContact = null;
    };
  }, [selectedContact]);

  // Keep unread counts + last message in sync with what the global listener stores
  useEffect(() => {
    const syncFromStorage = () => {
      const unread = getStoredUnreadCounts();
      const last = getStoredLastMessages();
      setContacts((prev) =>
        prev.map((c) => {
          const isSelected = selectedContactRef.current?.number === c.number;
          const u = isSelected ? 0 : unread[c.number] || 0;
          const l = last[c.number];
          let updated = c;
          if (u !== (c.unreadCount || 0)) updated = { ...updated, unreadCount: u };
          if (l && l.text && l.text !== c.lastMessage && toMs(l.timestamp) >= toMs(c.time)) {
            updated = { ...updated, lastMessage: l.text };
          }
          if (l && toMs(l.timestamp) > toMs(c.time)) {
            updated = { ...updated, time: l.timestamp };
          }
          return updated;
        })
      );
    };

    window.addEventListener("wa_unread_changed", syncFromStorage);
    window.addEventListener("wa_last_changed", syncFromStorage);
    return () => {
      window.removeEventListener("wa_unread_changed", syncFromStorage);
      window.removeEventListener("wa_last_changed", syncFromStorage);
    };
  }, [getStoredUnreadCounts, getStoredLastMessages]);

  const extractOriginalMessageId = (frontendId) => {
    if (!frontendId || typeof frontendId !== "string") return null;
    const parts = frontendId.split("-");
    if (parts[0].startsWith("wamid.")) return parts[0];
    return frontendId;
  };

  const formatMessageDate = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === now.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
    return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  };

  const formatSidebarTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === now.toDateString()) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    }
    return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  };

  const shouldShowDateSeparator = (currentMessage, previousMessage) => {
    if (!previousMessage) return true;
    const currentDate = new Date(currentMessage.timestamp).toDateString();
    const previousDate = new Date(previousMessage.timestamp).toDateString();
    return currentDate !== previousDate;
  };

  const DateSeparator = ({ date }) => (
    <div className="flex justify-center my-4">
      <div className="bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded-md shadow-sm">
        <span className="text-xs text-gray-600 dark:text-gray-300 font-medium tracking-wide">
          {date}
        </span>
      </div>
    </div>
  );

  const fetchUniqueSenders = async () => {
    if (!isConfigLoaded || !config.domain || !config.apiKey) return;

    try {
      setLoading(true);
      setError(null);

      const senderItems = [];
      let senderPage = 0;
      let hasMoreSenders = true;
      let senderFetchOk = true;

      while (hasMoreSenders && senderPage < 50) {
        const url = new URL(`${API_URL}/api/whatsapp-chat/unique-senders`);
        url.searchParams.append("page", senderPage);
        url.searchParams.append("size", 100);

        const pageResponse = await fetch(url.toString(), {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!pageResponse.ok) {
          senderFetchOk = false;
          break;
        }

        const pageData = await pageResponse.json();
        senderItems.push(...(pageData.data || []));
        hasMoreSenders = !!pageData.hasMore;
        senderPage = pageData.nextPage;
      }

      if (senderFetchOk) {
        const storedUnread = getStoredUnreadCounts();
        const storedLast = getStoredLastMessages();
        
        const formattedContacts = senderItems
          .filter((item) => item && item.number)
          .map((item, index) => {
            // Unread counts are maintained globally (Sidebar) and persisted in localStorage
            const finalUnread = storedUnread[item.number] || 0;

            return {
              id: index + 1,
              name: String(item.contactName || item.number),
              number: String(item.number),
              contactName: String(item.contactName || item.number),
              time: item.time,
              lastMessage: storedLast[item.number]?.text || "",
              unreadCount: finalUnread,
            };
          });

        setContacts(formattedContacts);
        const initialMessages = {};
        formattedContacts.forEach((contact) => (initialMessages[contact.id] = []));
        setMessages((prev) => ({ ...initialMessages, ...prev }));
      } else {
        throw new Error("Failed to fetch contacts");
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setError(error.message || "Failed to load contacts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isConfigLoaded) {
      fetchUniqueSenders();
    }
  }, [isConfigLoaded]);

  useEffect(() => {
    const targetNumber = location.state?.openContactNumber;
    if (!targetNumber) return;
    if (handledNotifRef.current === targetNumber) return;
    if (contacts.length === 0) return;

    const match = contacts.find((c) => c.number === targetNumber);
    if (match) {
      handledNotifRef.current = targetNumber;
      handleContactSelect(match);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [contacts, location.state, navigate, location.pathname]);

  const fetchChatMessages = async (contact, page = 0, append = false) => {
    if (!isConfigLoaded || !contact || !contact.number) return;

    try {
      if (append) {
        setLoadingMore(true);
        if (chatContainerRef.current) {
          previousScrollHeightRef.current = chatContainerRef.current.scrollHeight;
        }
        shouldMaintainScrollRef.current = true;
      } else {
        setChatLoading(true);
        shouldMaintainScrollRef.current = false;
        pendingMessagesRef.current.clear();
        setCurrentPage(0);
      }

      const url = new URL(`${API_URL}/api/whatsapp-chat/chat`);
      url.searchParams.append("sender", contact.number);
      url.searchParams.append("page", page);
      url.searchParams.append("size", pageSize);

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const data = await response.json();
        
        if (data.total !== undefined) {
          setTotalMessages(data.total);
          const totalPages = Math.ceil(data.total / pageSize);
          const nextPage = page + 1;
          setHasMoreMessages(nextPage < totalPages);
        }

        const messagesData = data.data || [];
        const sortedMessages = [...messagesData].sort((a, b) => {
          const timeA = new Date(a.timestamp || a.time || 0);
          const timeB = new Date(b.timestamp || b.time || 0);
          return timeA - timeB;
        });

        const formattedMessages = sortedMessages.map((msg, index) => {
          const messageId = msg.wamid || msg.messageId || `local-${Date.now()}-${index}`;
          const isPending = pendingMessagesRef.current.has(messageId);
          
          let messageText = msg.message || msg.text || "";
          const messageType = msg.type || "text";
          
          if (messageType === "image" && !messageText) {
            messageText = "📷 Photo";
          } else if (messageType === "video" && !messageText) {
            messageText = "🎥 Video";
          } else if (messageType === "audio" && !messageText) {
            messageText = "🎵 Audio";
          } else if (messageType === "document" && !messageText) {
            messageText = "📄 Document";
          }
          
          return {
            id: messageId,
            text: messageText,
            sender: msg.direction === "INCOMING" ? "them" : "me",
            time: msg.timestamp
              ? new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
              : new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
            timestamp: msg.timestamp || new Date().toISOString(),
            type: messageType,
            mediaId: msg.mediaId,
            mediaUrl: msg.mediaUrl,
            status: isPending ? "sent" : (msg.status || "read"),
            replyTo: msg.replyTo || null,
            reaction: msg.reaction || null,
          };
        });

        if (!append) {
          const newest = [...formattedMessages].reverse().find((m) => m.type !== "reaction");
          if (newest) {
            saveLastMessage(contact.number, {
              text: newest.text || MEDIA_TYPE_LABELS[newest.type] || `Sent a ${newest.type}`,
              type: newest.type,
              sender: newest.sender,
              timestamp: newest.timestamp,
            });
            if (selectedContactRef.current?.number === contact.number) {
              markContactRead(contact.number, newest.timestamp);
            }
          }
        }

        setMessages((prev) => {
          const contactId = contact.id;
          
          if (append) {
            const existingMessages = prev[contactId] || [];
            const existingIds = new Set(existingMessages.map(m => m.id));
            const newMessages = formattedMessages.filter(m => !existingIds.has(m.id));
            
            return {
              ...prev,
              [contactId]: [...newMessages, ...existingMessages],
            };
          } else {
            const pendingMsgs = Array.from(pendingMessagesRef.current.values())
              .filter(p => p.contactId === contactId);
            
            const pendingIds = new Set(pendingMsgs.map(p => p.id));
            const filteredMessages = formattedMessages.filter(m => !pendingIds.has(m.id));
            
            return {
              ...prev,
              [contactId]: [...filteredMessages, ...pendingMsgs],
            };
          }
        });
      } else {
        throw new Error("Failed to fetch chat messages");
      }
    } catch (error) {
      console.error("Error fetching chat messages:", error);
      setError(error.message || "Failed to load messages");
    } finally {
      if (append) {
        setLoadingMore(false);
        setTimeout(() => {
          if (chatContainerRef.current && previousScrollHeightRef.current) {
            const newScrollHeight = chatContainerRef.current.scrollHeight;
            const scrollOffset = newScrollHeight - previousScrollHeightRef.current;
            chatContainerRef.current.scrollTop = scrollOffset;
          }
          shouldMaintainScrollRef.current = false;
        }, 100);
      } else {
        setChatLoading(false);
        shouldMaintainScrollRef.current = false;
        setTimeout(() => {
          scrollToBottom();
        }, 200);
      }
    }
  };

  const loadMoreMessages = useCallback(async () => {
    if (!selectedContact || loadingMore || !hasMoreMessages || chatLoading) return;
    
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    await fetchChatMessages(selectedContact, nextPage, true);
  }, [selectedContact, currentPage, loadingMore, hasMoreMessages, chatLoading]);

  useEffect(() => {
    const chatContainer = chatContainerRef.current;
    if (!chatContainer) return;

    let scrollTimeout = null;
    
    const handleScroll = () => {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(() => {
        if (chatContainer.scrollTop <= 10 && hasMoreMessages && !loadingMore && !chatLoading) {
          loadMoreMessages();
        }
      }, 200);
    };

    chatContainer.addEventListener('scroll', handleScroll);
    return () => {
      chatContainer.removeEventListener('scroll', handleScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, [selectedContact, hasMoreMessages, loadingMore, loadMoreMessages, chatLoading]);

  const handleContactSelect = async (contact) => {
    setSelectedContact(contact);
    setReplyingTo(null);
    setActiveMenu(null);
    setShowEmojiPicker(false);
    setCurrentPage(0);
    setHasMoreMessages(true);
    setTotalMessages(0);
    shouldMaintainScrollRef.current = false;
    pendingMessagesRef.current.clear();

    // Clear locally and globally (also stores the "read up to" time)
    window.__waActiveContact = contact.number;
    markContactRead(contact.number, contact.time);
    setContacts(prev => prev.map(c => c.id === contact.id ? { ...c, unreadCount: 0 } : c));

    await fetchChatMessages(contact, 0, false);
  };

  const handleBackToContacts = () => {
    window.__waActiveContact = null;
    setSelectedContact(null);
    setReplyingTo(null);
    setActiveMenu(null);
  };

  const getReplyRefId = (replyTo) => {
    if (!replyTo) return null;
    if (typeof replyTo === "string") return replyTo;
    return replyTo.messageId || replyTo.wamid || null;
  };

  const MEDIA_TYPE_LABELS = {
    image: "📷 Photo",
    video: "🎥 Video",
    audio: "🎵 Audio",
    document: "📄 Document",
  };

  const getReplyPreview = (contactId, replyTo) => {
    const refId = getReplyRefId(replyTo);
    if (!refId) return null;

    const list = messages[contactId] || [];
    const original = list.find(
      (m) => {
        const mId = extractOriginalMessageId(m.id);
        return mId === refId || m.id === refId || m.id === replyTo;
      }
    );

    if (original) {
      return {
        label: original.sender === "me" ? "You" : (selectedContact?.contactName || "Customer"),
        text: original.text || MEDIA_TYPE_LABELS[original.type] || "Media",
        type: original.type,
      };
    }

    if (typeof replyTo === "object" && replyTo?.message) {
      return { 
        label: "Replying to", 
        text: replyTo.message,
        type: replyTo.type || "text"
      };
    }
    return { label: "Replying to", text: "Original message" };
  };

  const handleIncomingChatMessage = useCallback((contactId, rawBody) => {
    let msg;
    try {
      msg = JSON.parse(rawBody);
    } catch (e) {
      console.error("Failed to parse chatMessages WS payload:", e, rawBody);
      return;
    }

    const realId = msg.wamid || msg.messageId || null;

    if (msg.type === "reaction" || (msg.type === "text" && msg.text && msg.text.startsWith("Reacted with"))) {
      const reactionEmoji = msg.message || (msg.text ? msg.text.replace(/Reacted with | to your message/g, "").trim() : "👍");
      const idToMatch = getReplyRefId(msg.replyTo);

      if (idToMatch) {
        setMessages((prev) => {
          const existing = prev[contactId] || [];
          const updated = existing.map((m) =>
            extractOriginalMessageId(m.id) === idToMatch || m.id === idToMatch
              ? { ...m, reaction: reactionEmoji }
              : m
          );
          return { ...prev, [contactId]: updated };
        });
        return;
      }
    }

    if (realId && pendingMessagesRef.current.has(realId)) {
      const pending = pendingMessagesRef.current.get(realId);
      
      setMessages((prev) => {
        const existing = prev[contactId] || [];
        const updated = existing.map((m) => {
          if (m.id === pending.id || m.id === realId) {
            return {
              ...m,
              id: realId,
              status: msg.status || "delivered",
              mediaId: msg.mediaId || m.mediaId,
              mediaUrl: msg.mediaUrl || m.mediaUrl,
            };
          }
          return m;
        });
        
        const tempIndex = updated.findIndex(
          (m) => 
            m.id.startsWith("temp-") && 
            m.text === pending.text &&
            m.sender === "me"
        );
        
        if (tempIndex !== -1 && !updated.some(m => m.id === realId)) {
          updated[tempIndex] = {
            ...updated[tempIndex],
            id: realId,
            status: msg.status || "delivered",
            mediaId: msg.mediaId || updated[tempIndex].mediaId,
            mediaUrl: msg.mediaUrl || updated[tempIndex].mediaUrl,
          };
        }
        
        return { ...prev, [contactId]: updated };
      });
      
      pendingMessagesRef.current.delete(realId);
      return;
    }

    let messageText = msg.message || msg.text || "";
    const messageType = msg.type || "text";
    
    if (messageType === "image" && !messageText) {
      messageText = "📷 Photo";
    } else if (messageType === "video" && !messageText) {
      messageText = "🎥 Video";
    } else if (messageType === "audio" && !messageText) {
      messageText = "🎵 Audio";
    } else if (messageType === "document" && !messageText) {
      messageText = "📄 Document";
    }

    const formatted = {
      id: realId || `ws-${Date.now()}`,
      text: messageText,
      sender: msg.direction === "INCOMING" ? "them" : "me",
      time: msg.timestamp
        ? new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        : new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      timestamp: msg.timestamp || new Date().toISOString(),
      type: messageType,
      mediaId: msg.mediaId || null,
      mediaUrl: msg.mediaUrl || null,
      status: msg.status || (msg.direction === "INCOMING" ? "delivered" : "sent"),
      replyTo: msg.replyTo || null,
    };

    setMessages((prev) => {
      const existing = prev[contactId] || [];
      
      const duplicate = existing.some(
        (m) => 
          extractOriginalMessageId(m.id) === realId || 
          m.id === realId ||
          (m.text === formatted.text && 
           m.sender === formatted.sender &&
           Math.abs(new Date(m.timestamp) - new Date(formatted.timestamp)) < 5000)
      );
      
      if (duplicate) {
        const updated = existing.map((m) => {
          if (extractOriginalMessageId(m.id) === realId || m.id === realId) {
            return { ...m, status: formatted.status || m.status };
          }
          return m;
        });
        return { ...prev, [contactId]: updated };
      }

      return { ...prev, [contactId]: [...existing, formatted] };
    });

    // Last message (received OR sent). Unread counting is handled globally by the Sidebar
    // listener; the badge here updates through the "wa_unread_changed" event.
    const previewText = formatted.text || MEDIA_TYPE_LABELS[formatted.type] || `Sent a ${formatted.type}`;
    const contactNumber = contactsRef.current.find((c) => c.id === contactId)?.number;
    saveLastMessage(contactNumber, {
      text: previewText,
      type: formatted.type,
      sender: formatted.sender,
      timestamp: formatted.timestamp,
    });
    setContacts((prev) =>
      prev.map((c) =>
        c.id === contactId && toMs(formatted.timestamp) >= toMs(c.time)
          ? { ...c, lastMessage: previewText, time: formatted.timestamp }
          : c
      )
    );
  }, [saveLastMessage]);

  const handleStatusUpdate = useCallback((contactId, rawBody) => {
    let data;
    try {
      data = JSON.parse(rawBody);
    } catch (e) {
      console.error("Failed to parse chatStatusUpdate WS payload:", e, rawBody);
      return;
    }

    const targetId = data.messageId || data.wamid;
    let status = (data.status || "").toLowerCase();
    if (!targetId || !status) return;
    if (status === "seen") status = "read";

    setMessages((prev) => {
      const existing = prev[contactId] || [];
      const updated = existing.map((m) =>
        extractOriginalMessageId(m.id) === targetId || m.id === targetId
          ? { ...m, status }
          : m
      );
      return { ...prev, [contactId]: updated };
    });
  }, []);

  const subscribeToContact = useCallback(
    (contact) => {
      const client = stompClientRef.current;
      if (!client || !client.connected || !contact?.number || !config.apiKey) return;

      const msgTopic = `/topic/chatMessages/${config.apiKey}/${contact.number}`;
      const statusTopic = `/topic/chatStatusUpdate/${config.apiKey}/${contact.number}`;

      if (!subscriptionsRef.current[msgTopic]) {
        subscriptionsRef.current[msgTopic] = client.subscribe(msgTopic, (frame) => {
          handleIncomingChatMessage(contact.id, frame.body);
        });
      }

      if (!subscriptionsRef.current[statusTopic]) {
        subscriptionsRef.current[statusTopic] = client.subscribe(statusTopic, (frame) => {
          handleStatusUpdate(contact.id, frame.body);
        });
      }
    },
    [config.apiKey, handleIncomingChatMessage, handleStatusUpdate]
  );

  useEffect(() => {
    if (!isConfigLoaded || !config.apiKey) return;

    const client = new Client({
      brokerURL: WS_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      onConnect: () => {
        setWsConnected(true);
        contactsRef.current.forEach(subscribeToContact);
      },
      onDisconnect: () => {
        setWsConnected(false);
      },
      onWebSocketClose: () => {
        setWsConnected(false);
      },
    });

    stompClientRef.current = client;
    client.activate();

    return () => {
      Object.values(subscriptionsRef.current).forEach((sub) => {
        try {
          sub.unsubscribe();
        } catch (_) { }
      });
      subscriptionsRef.current = {};
      client.deactivate();
      stompClientRef.current = null;
      setWsConnected(false);
    };
  }, [isConfigLoaded, config.apiKey, subscribeToContact]);

  useEffect(() => {
    contactsRef.current = contacts;
    if (stompClientRef.current?.connected) {
      contacts.forEach(subscribeToContact);
    }
  }, [contacts, subscribeToContact]);

  const handleSendMessage = async () => {
    if ((!newMessage.trim() && !selectedFile) || !selectedContact || sending) return;

    setShowEmojiPicker(false);

    const tempId = `temp-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
    
    let replyText = "";
    if (replyingTo) {
      replyText = replyingTo.text || MEDIA_TYPE_LABELS[replyingTo.type] || "Media";
    }
    
    const tempMsg = {
      id: tempId,
      text: newMessage || (selectedFile ? `📎 ${fileType}` : ""),
      sender: "me",
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      timestamp: new Date().toISOString(),
      type: fileType,
      mediaUrl: selectedFile ? URL.createObjectURL(selectedFile) : null,
      status: "sending",
      replyTo: replyingTo ? { 
        messageId: replyingTo.id, 
        message: replyText, 
        type: replyingTo.type || "text",
        sender: replyingTo.sender
      } : null,
    };

    pendingMessagesRef.current.set(tempId, {
      ...tempMsg,
      contactId: selectedContact.id,
    });

    setMessages((prev) => ({
      ...prev,
      [selectedContact.id]: [...(prev[selectedContact.id] || []), tempMsg],
    }));

    setContacts(prev => prev.map(c => 
      c.id === selectedContact.id 
        ? { ...c, time: tempMsg.timestamp, lastMessage: tempMsg.text || `Sent a ${fileType}` } 
        : c
    ));
    saveLastMessage(selectedContact.number, {
      text: tempMsg.text || `Sent a ${fileType}`,
      type: fileType,
      sender: "me",
      timestamp: tempMsg.timestamp,
    });

    const messageToSend = newMessage;
    const fileToSend = selectedFile;
    const currentFileType = fileType;
    const replyMessageId = replyingTo ? extractOriginalMessageId(replyingTo.id) : null;

    setNewMessage("");
    setSelectedFile(null);
    setFileType("text");
    setReplyingTo(null);

    try {
      setSending(true);
      const formData = new FormData();
      formData.append("apiKey", config.apiKey);
      formData.append("to", selectedContact.number);
      
      if (messageToSend) {
        formData.append("message", messageToSend);
      } else if (fileToSend) {
        formData.append("message", `Sent a ${currentFileType}`);
      }
      
      if (currentFileType) formData.append("type", currentFileType);

      if (replyMessageId) {
        formData.append("replyMessageId", replyMessageId);
      }

      if (fileToSend && currentFileType !== "text") {
        formData.append("file", fileToSend);
      }

      const response = await fetch(`${API_URL}/api/whatsapp-chat/reply`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const responseData = await response.json();

      if (!response.ok || responseData.status !== "success") {
        throw new Error(responseData.message || "Failed to send message");
      }

      setMessages((prev) => {
        const existing = prev[selectedContact.id] || [];
        const updated = existing.map((m) =>
          m.id === tempId ? { ...m, status: "sent" } : m
        );
        return { ...prev, [selectedContact.id]: updated };
      });

      if (responseData.wamid || responseData.messageId) {
        const realId = responseData.wamid || responseData.messageId;
        
        const pending = pendingMessagesRef.current.get(tempId);
        if (pending) {
          pendingMessagesRef.current.delete(tempId);
          pendingMessagesRef.current.set(realId, {
            ...pending,
            id: realId,
          });
        }
        
        setMessages((prev) => {
          const existing = prev[selectedContact.id] || [];
          const updated = existing.map((m) =>
            m.id === tempId ? { ...m, id: realId, status: "sent" } : m
          );
          return { ...prev, [selectedContact.id]: updated };
        });
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      
      pendingMessagesRef.current.delete(tempId);
      
      setMessages((prev) => ({
        ...prev,
        [selectedContact.id]: (prev[selectedContact.id] || []).filter((msg) => msg.id !== tempId),
      }));
      
      alert("Failed to send message. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const handleReactToMessage = async (messageToReact, emoji) => {
    setActiveMenu(null);
    if (!selectedContact) return;

    setMessages((prev) => {
      const existing = prev[selectedContact.id] || [];
      const updated = existing.map(m => m.id === messageToReact.id ? { ...m, reaction: emoji } : m);
      return { ...prev, [selectedContact.id]: updated };
    });

    try {
      const formData = new FormData();
      formData.append("apiKey", config.apiKey);
      formData.append("to", selectedContact.number);
      formData.append("message", emoji);
      formData.append("type", "reaction");
      formData.append("replyMessageId", extractOriginalMessageId(messageToReact.id));

      await fetch(`${API_URL}/api/whatsapp-chat/reply`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
    } catch (err) {
      console.error("Failed to send reaction:", err);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    if (file.type.startsWith("image/")) setFileType("image");
    else if (file.type.startsWith("video/")) setFileType("video");
    else if (file.type.startsWith("audio/")) setFileType("audio");
    else setFileType("document");
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setFileType("text");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const toggleMenu = (e, msgId) => {
    e.stopPropagation();
    if (activeMenu?.id === msgId) {
      setActiveMenu(null);
    } else {
      const rect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const direction = spaceBelow < 220 ? 'up' : 'down';
      setActiveMenu({ id: msgId, direction });
    }
  };

  const getMenuIcon = (type) => {
    switch (type) {
      case 'info': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4m0-4h.01" /></svg>;
      case 'reply': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" /></svg>;
      case 'copy': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" /></svg>;
      case 'react': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" /></svg>;
      case 'forward': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10h-10a8 8 0 00-8 8v2M21 10l-6 6m6-6l-6-6" /></svg>;
      case 'pin': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v6m-4 4l8-8M4 14l8-8m-4 12l2 4 2-4" /></svg>;
      case 'ai': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zM12 6v6l4 2" /></svg>;
      case 'star': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1 3-6z" /></svg>;
      case 'delete': return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" /></svg>;
      default: return null;
    }
  };

  const renderMessageWithReplies = (message, index) => {
    const previousMessage = messages[selectedContact.id]?.[index - 1];
    const showDateSeparator = shouldShowDateSeparator(message, previousMessage);
    const isReply = !!message.replyTo;
    const replyPreview = isReply ? getReplyPreview(selectedContact.id, message.replyTo) : null;
    const isMenuOpen = activeMenu?.id === message.id;
    const isSending = message.status === "sending";

    const menuPositionClasses = activeMenu?.direction === 'up'
      ? `bottom-full mb-1 ${message.sender === 'me' ? 'origin-bottom-right right-0' : 'origin-bottom-left left-0'}`
      : `top-8 ${message.sender === 'me' ? 'origin-top-right right-0' : 'origin-top-left left-0'}`;

    return (
      <div key={message.id} id={`message-${message.id}`} className="relative">
        {showDateSeparator && <DateSeparator date={formatMessageDate(message.timestamp)} />}

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className={`flex ${message.sender === "me" ? "justify-end" : "justify-start"} mb-4`}
        >
          <div className="relative group max-w-[85%] md:max-w-md flex flex-col">
            <div
              className={`px-3 py-2 rounded-xl shadow-sm relative ${message.sender === "me"
                ? `bg-[#dcf8c6] dark:bg-[#056162] text-gray-900 dark:text-white rounded-tr-none ${isSending ? 'opacity-70' : ''}`
                : "bg-white dark:bg-[#202c33] text-gray-900 dark:text-white rounded-tl-none border border-gray-100 dark:border-gray-800"
                }`}
            >
              <button
                onClick={(e) => toggleMenu(e, message.id)}
                className={`menu-trigger-btn absolute top-0 right-0 m-1 p-0.5 rounded-full text-gray-500 dark:text-gray-300 shadow-sm opacity-0 group-hover:opacity-100 transition-opacity z-20 ${isMenuOpen ? 'opacity-100 bg-white dark:bg-[#202c33]' : 'bg-white/80 dark:bg-[#202c33]/80 backdrop-blur-sm'
                  }`}
              >
                <svg viewBox="0 0 18 18" width="18" height="18" fill="currentColor">
                  <path d="M3.3 5.3l5.7 5.7 5.7-5.7 1.6 1.6-7.3 7.2-7.3-7.2 1.6-1.6z"></path>
                </svg>
              </button>

              {isMenuOpen && (
                <div className={`message-menu-container absolute ${menuPositionClasses} w-52 bg-white dark:bg-[#233138] rounded-xl shadow-xl border border-gray-200 dark:border-[#323d43] z-50 flex flex-col transform transition-transform`}>
                  <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200 dark:border-[#323d43]">
                    {['👍', '❤️', '😂', '😮', '😢', '🙏'].map(emoji => (
                      <button
                        key={emoji}
                        onClick={(e) => { e.stopPropagation(); handleReactToMessage(message, emoji); }}
                        className="text-xl hover:scale-125 transition-transform"
                      >
                        {emoji}
                      </button>
                    ))}
                  </div>
                  <div className="flex flex-col py-1 overflow-hidden">
                    {[
                      { id: 'info', label: 'Message info' },
                      {
                        id: 'reply', label: 'Reply', action: () => {
                          setActiveMenu(null);
                          setReplyingTo(message);
                          setTimeout(() => inputRef.current?.focus(), 50);
                        }
                      }, { id: 'copy', label: 'Copy', action: () => { setActiveMenu(null); navigator.clipboard.writeText(message.text || ''); } },
                      { id: 'forward', label: 'Forward' },
                      { id: 'delete', label: 'Delete' }
                    ].map(option => (
                      <button
                        key={option.id}
                        onClick={(e) => { e.stopPropagation(); if (option.action) option.action(); }}
                        className="w-full text-left px-4 py-2.5 hover:bg-gray-100 dark:hover:bg-[#182229] flex items-center space-x-4 text-[15px] text-gray-800 dark:text-[#d1d7db] transition-colors"
                      >
                        <span className="flex justify-center text-gray-500 dark:text-[#8696a0]">{getMenuIcon(option.id)}</span>
                        <span>{option.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {isReply && replyPreview && (
                <div
                  className="mb-2 p-2 bg-black/5 dark:bg-black/20 rounded-lg border-l-4 border-green-500 flex flex-col cursor-pointer"
                  onClick={() => {
                    const refId = getReplyRefId(message.replyTo);
                    if (refId) {
                      const target = document.querySelector(`[id$="${refId}"]`) || document.getElementById(`message-${refId}`);
                      target?.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                  }}
                >
                  <span className="text-xs font-semibold text-green-600 dark:text-green-400 mb-1">
                    {replyPreview?.label || "Replying to"}
                  </span>
                  <p className="text-sm text-gray-700 dark:text-gray-300 truncate opacity-90">
                    {replyPreview?.text || "Media"}
                  </p>
                </div>
              )}

              <LazyMediaContent message={message} getMediaSrc={getMediaSrc} />

              {message.text && message.type === "text" && (
                <p className="text-[15px] leading-relaxed break-words whitespace-pre-wrap">{message.text}</p>
              )}

              <div className="flex justify-end items-center mt-1 space-x-1">
                <p className="text-[11px] text-gray-500 dark:text-gray-400/80">
                  {message.time}
                </p>
                {message.sender === "me" && (
                  <div className="ml-1">
                    {message.status === "sending" && (
                      <div className="w-3 h-3 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                    )}
                    {message.status === "sent" && <FontAwesomeIcon icon={faCheck} className="text-gray-400 text-[11px]" />}
                    {message.status === "delivered" && <FontAwesomeIcon icon={faCheckDouble} className="text-gray-400 text-[11px]" />}
                    {message.status === "read" && <FontAwesomeIcon icon={faCheckDouble} className="text-blue-500 text-[11px]" />}
                    {message.status === "failed" && <span className="text-red-500 text-[11px]">!</span>}
                  </div>
                )}
              </div>
            </div>

            {message.reaction && (
              <div
                className={`absolute -bottom-3 ${message.sender === 'me' ? 'right-2' : 'left-2'} bg-white dark:bg-[#2a3942] border border-gray-200 dark:border-[#111b21] rounded-full px-1.5 py-0.5 text-[13px] shadow-sm z-10 flex items-center justify-center`}
              >
                {message.reaction}
              </div>
            )}
          </div>
        </motion.div>
      </div>
    );
  };

  const filteredContacts = contacts
    .filter((contact) =>
      (contact.contactName && contact.contactName.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (contact.number && contact.number.includes(searchQuery))
    )
    .sort((a, b) => {
      const dateA = a.time ? new Date(a.time).getTime() : 0;
      const dateB = b.time ? new Date(b.time).getTime() : 0;
      return dateB - dateA;
    });

  return (
    <div className="flex h-[93vh] bg-[#f0f2f5] dark:bg-[#111b21] font-sans">
      <div
        className={`${isMobileView && selectedContact ? "hidden" : "flex"
          } w-full md:w-[350px] lg:w-[400px] bg-white dark:bg-[#111b21] border-r border-gray-200 dark:border-gray-800 flex-col z-10`}
      >
        <div className="bg-[#f0f2f5] dark:bg-[#202c33] p-4 flex justify-between items-center h-16">
          <div className="flex items-center gap-2">
            <img src={Image1} alt="Logo" className="w-6 h-6 object-contain rounded-sm" />
            <h1 className="text-[15px] font-semibold text-gray-800 dark:text-[#e9edef]">Powered by Nipane</h1>
            <span
              title={wsConnected ? "Live" : "Reconnecting..."}
              className={`w-2 h-2 ml-1 rounded-full ${wsConnected ? "bg-green-500" : "bg-gray-400 animate-pulse"}`}
            />
          </div>
          <button onClick={fetchUniqueSenders} className="p-2 text-gray-600 dark:text-[#aebac1] bg-transparent outline-none border-none">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>
        </div>

        <div className="p-2 bg-white dark:bg-[#111b21]">
          <div className="bg-[#f0f2f5] dark:bg-[#202c33] rounded-lg flex items-center px-3 py-1.5">
            <svg className="h-5 w-5 text-gray-500 dark:text-[#aebac1]" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
            <input
              type="text"
              placeholder="Search or start new chat"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-transparent border-none focus:ring-0 text-sm text-gray-800 dark:text-[#e9edef] placeholder-gray-500 px-3 py-1 outline-none"
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          {error ? (
            <div className="p-4 text-center text-red-500 text-sm">{error}</div>
          ) : loading ? (
            <div className="p-4 text-center text-gray-500 text-sm">Syncing chats...</div>
          ) : filteredContacts.map((contact) => (
            <div
              key={contact.id}
              className={`flex items-center px-4 py-3 cursor-pointer border-b border-gray-100 dark:border-[#202c33]/50 transition-colors ${selectedContact?.id === contact.id ? "bg-[#f0f2f5] dark:bg-[#2a3942]" : "hover:bg-[#f5f6f6] dark:hover:bg-[#202c33]"
                }`}
              onClick={() => handleContactSelect(contact)}
            >
              <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-medium text-lg ${getAvatarColor(contact.contactName)}`}>
                {getAvatarInitials(contact.contactName)}
              </div>
              <div className="ml-4 flex-1 min-w-0">
                <div className="flex justify-between items-baseline">
                  <h2 className="text-[17px] font-normal text-gray-900 dark:text-[#e9edef] truncate">{contact.contactName}</h2>
                  {contact.time && (
                    <span className="text-[12px] text-gray-500 dark:text-[#8696a0] ml-2 shrink-0">
                      {formatSidebarTime(contact.time)}
                    </span>
                  )}
                </div>
                <div className="flex justify-between items-center mt-0.5">
                  <p className="text-[13px] text-gray-500 dark:text-[#8696a0] truncate">{contact.lastMessage || 'Tap to view chat'}</p>
                  {contact.unreadCount > 0 && (
                    <span className="bg-[#00a884] text-white text-[11px] font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center ml-2 shadow-sm">
                      {contact.unreadCount}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
          {filteredContacts.length === 0 && !loading && (
            <div className="p-4 text-center text-gray-500 text-sm">No chats found.</div>
          )}
        </div>
      </div>

      <div className={`${isMobileView && !selectedContact ? "hidden" : "flex"} flex-1 flex-col relative`}>
        {selectedContact ? (
          <>
            <div className="bg-[#f0f2f5] dark:bg-[#202c33] px-4 py-2.5 flex items-center h-16 z-20">
              {isMobileView && (
                <button onClick={handleBackToContacts} className="mr-3 text-gray-600 dark:text-gray-300 bg-transparent outline-none border-none">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
              )}
              <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white ${getAvatarColor(selectedContact.contactName)}`}>
                {getAvatarInitials(selectedContact.contactName)}
              </div>
              <div className="ml-4">
                <h2 className="text-[16px] font-medium text-gray-900 dark:text-[#e9edef]">
                  {selectedContact.contactName}
                </h2>
                <p className="text-[13px] text-gray-500 dark:text-[#8696a0]">
                  +{selectedContact.number} • Business Account
                </p>
              </div>
            </div>

            <div className="flex-1 relative bg-[#efeae2] dark:bg-[#0b141a]">
              <div
                className="absolute inset-0 z-0 opacity-[0.65] dark:opacity-[0.25] mix-blend-multiply dark:mix-blend-overlay pointer-events-none"
                style={{
                  backgroundImage: `url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')`,
                  backgroundRepeat: 'repeat',
                  backgroundSize: '400px',
                  backgroundPosition: 'center'
                }}
              />
              <div className="absolute inset-0 z-10 overflow-y-auto p-4 chat-messages-container" ref={chatContainerRef}>
                {chatLoading ? (
                  <div className="flex justify-center items-center h-full">
                    <span className="text-sm text-gray-500 bg-white dark:bg-gray-800 px-4 py-2 rounded-full shadow-sm">Loading messages...</span>
                  </div>
                ) : (
                  <div className="space-y-1">
                    {loadingMore && (
                      <div className="flex justify-center py-4">
                        <div className="flex items-center space-x-2 text-sm text-gray-500 bg-white dark:bg-gray-800 px-4 py-2 rounded-full shadow-sm">
                          <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-gray-500"></div>
                          <span>Loading older messages...</span>
                        </div>
                      </div>
                    )}
                    
                    {!hasMoreMessages && messages[selectedContact.id]?.length > 0 && (
                      <div className="flex justify-center py-4">
                        <span className="text-xs text-gray-400 bg-white dark:bg-gray-800 px-3 py-1 rounded-full shadow-sm">
                          No more messages to load
                        </span>
                      </div>
                    )}
                    
                    {totalMessages > 0 && messages[selectedContact.id]?.length > 0 && (
                      <div className="flex justify-center py-2">
                        <span className="text-xs text-gray-400 bg-white dark:bg-gray-800 px-3 py-1 rounded-full shadow-sm">
                          Showing {messages[selectedContact.id]?.length || 0} of {totalMessages} messages
                        </span>
                      </div>
                    )}
                    
                    <AnimatePresence>
                      {messages[selectedContact.id]?.map((message, index) => renderMessageWithReplies(message, index))}
                    </AnimatePresence>
                    <div ref={messagesEndRef} className="h-4" />
                  </div>
                )}
              </div>
            </div>

            <div className="bg-[#f0f2f5] dark:bg-[#202c33] px-4 py-3 flex flex-col justify-end z-20 relative">
              {replyingTo && (
                <div className="mb-2 p-3 bg-white dark:bg-[#2a3942] border-l-4 border-[#00a884] rounded-lg shadow-sm flex items-center justify-between">
                  <div className="flex-1 min-w-0">
                    <p className="text-[13px] font-semibold text-[#00a884]">
                      Replying to {replyingTo.sender === 'me' ? 'yourself' : selectedContact?.contactName}
                    </p>
                    <p className="text-[13px] text-gray-600 dark:text-gray-300 truncate">
                      {replyingTo.text || MEDIA_TYPE_LABELS[replyingTo.type] || 'Media'}
                    </p>
                  </div>
                  <button onClick={() => setReplyingTo(null)} className="text-gray-500 hover:text-gray-700 dark:text-gray-400 bg-transparent outline-none border-none ml-3 flex-shrink-0">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              )}

              {selectedFile && (
                <div className="mb-2 p-3 bg-white dark:bg-[#2a3942] rounded-lg shadow-sm flex items-center justify-between border border-gray-200 dark:border-gray-700">
                  <div className="flex items-center">
                    {fileType === "image" ? (
                      <img src={URL.createObjectURL(selectedFile)} alt="Preview" className="h-10 w-10 object-cover rounded" />
                    ) : fileType === "audio" ? (
                      <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">🎵</div>
                    ) : fileType === "video" ? (
                      <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">🎥</div>
                    ) : (
                      <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">📄</div>
                    )}
                    <span className="ml-3 text-sm text-gray-700 dark:text-gray-300 truncate max-w-[200px]">{selectedFile.name}</span>
                  </div>
                  <button onClick={handleRemoveFile} className="text-white bg-transparent outline-none border-none ml-3">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              )}

              {showEmojiPicker && (
                <div className="absolute bottom-[65px] left-4 z-50 shadow-2xl rounded-lg border border-gray-200 dark:border-gray-700">
                  <EmojiPicker
                    onEmojiClick={(emojiObject) => {
                      setNewMessage((prev) => prev + emojiObject.emoji);
                    }}
                    theme="auto"
                  />
                </div>
              )}

              <div className="flex items-center space-x-2 w-full">
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileSelect}
                  accept=".jpg,.jpeg,.png,.gif,.mp4,.3gp,.pdf,.doc,.docx,.txt,.mp3,.ogg,.opus,.aac,.wav"
                  className="hidden"
                />

                <button
                  onClick={() => fileInputRef.current?.click()}
                  className="p-2 text-gray-500 dark:text-[#aebac1] bg-transparent hover:bg-black/5 dark:hover:bg-white/5 rounded-full transition-colors outline-none border-none"
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                  </svg>
                </button>

                <button
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                  className={`p-2 bg-transparent rounded-full transition-colors outline-none border-none ${showEmojiPicker ? "text-[#00a884] bg-black/5 dark:bg-white/5" : "text-gray-500 dark:text-[#aebac1] hover:bg-black/5 dark:hover:bg-white/5"}`}
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"></path>
                  </svg>
                </button>

                <div className="flex-1 bg-white dark:bg-[#2a3942] rounded-xl overflow-hidden shadow-sm flex items-center">
                  <input
                    type="text"
                    ref={inputRef}
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Type a message"
                    disabled={sending}
                    className="w-full bg-transparent border-none focus:ring-0 py-2.5 px-4 text-[15px] text-gray-900 dark:text-[#e9edef] placeholder-gray-500 dark:placeholder-[#8696a0] outline-none"
                  />
                </div>

                {(newMessage.trim() || selectedFile) && (
                  <button
                    onClick={handleSendMessage}
                    disabled={sending}
                    className={`px-5 py-2 rounded-full font-medium flex items-center justify-center transition-colors outline-none border-none text-[15px] ${!sending
                      ? "bg-[#00a884] text-white hover:bg-[#008f6f]"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
                      }`}
                  >
                    {sending ? "Sending..." : "Send"}
                  </button>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center bg-[#f0f2f5] dark:bg-[#111b21] relative">
            <div
              className="absolute inset-0 z-0 opacity-[0.55] dark:opacity-[0.2] mix-blend-multiply dark:mix-blend-overlay pointer-events-none"
              style={{
                backgroundImage: `url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')`,
                backgroundRepeat: 'repeat',
                backgroundSize: '400px',
                backgroundPosition: 'center'
              }}
            />
            <div className="relative z-10 flex flex-col items-center">
              <h2 className="text-3xl font-light text-gray-700 dark:text-[#e9edef] mt-8 mb-4">WhatsApp Web</h2>
              <p className="text-sm text-gray-700 dark:text-[#8696a0] max-w-md text-center dark:bg-black/40 px-4 py-2 rounded-lg backdrop-blur-sm">
                Send and receive messages without keeping your phone online.<br />
                Select a contact from the sidebar to view your conversation.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const LazyMediaContent = ({ message, getMediaSrc }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [src, setSrc] = useState(null);

  if (!message.mediaUrl && !message.mediaId) return null;

  const handleMediaClick = () => {
    if (isLoaded) {
      setIsModalOpen(true);
      return;
    }
    
    setIsLoading(true);
    const mediaSrc = getMediaSrc(message);
    
    if (!mediaSrc) {
      setIsLoading(false);
      setLoadFailed(true);
      return;
    }
    
    setSrc(mediaSrc);
    
    if (message.type === "image") {
      const img = new Image();
      img.onload = () => {
        setIsLoaded(true);
        setIsLoading(false);
        setIsModalOpen(true);
      };
      img.onerror = () => {
        setIsLoading(false);
        setLoadFailed(true);
      };
      img.src = mediaSrc;
    } else {
      setIsLoaded(true);
      setIsLoading(false);
      setIsModalOpen(true);
    }
  };

  if (!isLoaded && !isLoading && !loadFailed) {
    return (
      <button
        onClick={handleMediaClick}
        className="mt-2 w-full p-4 bg-black/5 dark:bg-black/20 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 hover:border-green-500 dark:hover:border-green-400 transition-all duration-200 flex flex-col items-center justify-center gap-2"
      >
        <span className="text-3xl">
          {message.type === "image" && "🖼️"}
          {message.type === "video" && "🎥"}
          {message.type === "audio" && "🎵"}
          {message.type === "document" && "📄"}
        </span>
        <span className="text-sm text-gray-600 dark:text-gray-300 font-medium">
          {message.type === "image" && "Tap to view photo"}
          {message.type === "video" && "Tap to play video"}
          {message.type === "audio" && "Tap to play audio"}
          {message.type === "document" && "Tap to view document"}
        </span>
        <span className="text-xs text-gray-400 dark:text-gray-500">
          Click to load
        </span>
      </button>
    );
  }

  if (isLoading) {
    return (
      <div className="mt-2 p-4 bg-black/5 dark:bg-black/20 rounded-lg flex flex-col items-center justify-center gap-2">
        <div className="animate-spin rounded-full h-8 w-8 border-4 border-green-500 border-t-transparent"></div>
        <span className="text-sm text-gray-500 dark:text-gray-400">Loading media...</span>
      </div>
    );
  }

  if (loadFailed) {
    return (
      <div className="mt-2 p-4 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
        <p className="text-sm text-red-600 dark:text-red-400">Failed to load media</p>
        <button
          onClick={handleMediaClick}
          className="mt-2 text-sm text-blue-500 hover:text-blue-400"
        >
          Try again
        </button>
      </div>
    );
  }

  const renderMedia = () => {
    if (message.type === "image") {
      return (
        <img
          src={src}
          alt="Shared content"
          className="max-w-full rounded-lg max-h-64 object-contain cursor-pointer hover:opacity-90 transition-opacity"
          onClick={() => setIsModalOpen(true)}
          onError={() => {
            setLoadFailed(true);
            setIsLoaded(false);
          }}
        />
      );
    }

    if (message.type === "video") {
      return (
        <video
          controls
          preload="metadata"
          className="max-w-full rounded-lg max-h-64 object-contain"
          onError={() => {
            setLoadFailed(true);
            setIsLoaded(false);
          }}
        >
          <source src={src} />
          Your browser doesn't support embedded videos.
        </video>
      );
    }

    if (message.type === "audio") {
      return (
        <audio
          controls
          preload="metadata"
          className="w-full h-10"
          onError={() => {
            setLoadFailed(true);
            setIsLoaded(false);
          }}
        >
          <source src={src} />
          Your browser doesn't support the audio element.
        </audio>
      );
    }

    if (message.type === "document") {
      return (
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg text-blue-500 hover:text-blue-400 font-medium text-sm"
        >
          📄 Open Document
        </a>
      );
    }

    return null;
  };

  return (
    <>
      <div className="mt-2">
        {renderMedia()}
      </div>

      {isModalOpen && message.type === "image" && (
        <div
          className="fixed z-[100] bg-black/95 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setIsModalOpen(false)}
        >
          <button
            className="absolute top-6 right-6 text-white text-4xl opacity-80 hover:opacity-100 font-light z-50 outline-none"
            onClick={() => setIsModalOpen(false)}
          >
            &times;
          </button>
          <img
            src={src}
            alt="Expanded content"
            className="max-w-full max-h-full object-contain cursor-default"
            onClick={(e) => e.stopPropagation()}
            onError={() => {
              setLoadFailed(true);
              setIsLoaded(false);
              setIsModalOpen(false);
            }}
          />
        </div>
      )}
    </>
  );
};

export default Chat;